"use strict";

/* jshint -W098 */
angular.module("mean.foreman").controller("ForemanDailyReportController", [
  "$scope",
  "$rootScope",
  "$window",
  "$q",
  "Users",
  "Global",
  "Upload",
  "Foreman",
  "MeanUser",
  "ProjectTasks",
  "$filter",
  "Projects",
  "$location",
  "ProjectHours",
  "Builders",
  "Holidays",
  "tradeCodeService",
  "taskListService",
  "toaster",
  "userService",
  "myCoordinates",
  "Hours",
  "ngDialog",
  "foremanCalendarService",
  "Trades",
  "aceUtils",
  "PayPeriodService",
  "Timecards",
  "timeService",
  "$timeout",
  "AWSUploadService",
  "DocumentSevice",
  "$http",
  function (
    $scope,
    $rootScope,
    $window,
    $q,
    Users,
    Global,
    Upload,
    Foreman,
    MeanUser,
    ProjectTasks,
    $filter,
    Projects,
    $location,
    ProjectHours,
    Builders,
    Holidays,
    tradeCodeService,
    taskListService,
    toaster,
    userService,
    myCoordinates,
    Hours,
    ngDialog,
    foremanCalendarService,
    Trades,
    aceUtils,
    PayPeriodService,
    Timecards,
    timeService,
    $timeout,
    AWSUploadService,
    DocumentSevice,
    $http
  ) {
    $scope.global = Global;
    $scope.package = {
      name: "foreman",
    };
    $scope.user = MeanUser.user;
    $scope.lotSelection = [];
    $scope.bonus = "";
    $scope.lot_has_one = false;
    $scope.has_many = false;
    $scope.foremanChangeEvent = false;
    $scope.workerChangeEvent = false;
    $scope.finalSubmitChecker = false;
    $scope.updateandexit = false;
    $scope.showSpinner = false;
    $scope.formanTasks = [];
    $scope.workerTasks = [];
    $scope.main_id = null;
    $scope.selectedForeman = null;
    $scope.require_passwords = true;

    $scope.project_reports = [];

    //$scope.current_timecards = [];

    foremanCalendarService.setHolidaysArray($scope.user.username);

    var loginDialog = null;

    $rootScope.$on("crewHourUpdated", function (event, data) {
      var index = -1;
      for (var i = 0; i < $scope.clock_hours.length; i++) {
        if ($scope.clock_hours[i]._id === data._id) {
          index = i;
          break;
        }
      }

      if (index === -1) {
        $scope.clock_hours.push(data);
      } else {
        $scope.clock_hours.splice(index, 1, data);
      }
    });

    $scope.typical = null;

    timeService
      .getStandardHours($scope.user.trade[0], $scope.user.contractor_code)
      .then(function (typical) {
        $scope.typical = typical;
      });

    $scope.example15settings = {
      buttonClasses: "form-control",
      externalIdProp: "",
      scrollable: true,
      scrollableHeight: "140px",
      enableSearch: false,
      smartButtonMaxItems: 1,
      smartButtonTextConverter: function (itemText, originalItem) {
        if ($scope.lotSelection.length > 1) {
          return $scope.lotSelection.length + " checked";
        } else {
          return itemText;
        }
      },
    };

    $scope.workersettings = {
      buttonClasses: "form-control",
      externalIdProp: "",
      enableSearch: false,
      scrollable: true,
      scrollableHeight: "140px",
      smartButtonMaxItems: 1,
      smartButtonTextConverter: function (itemText, originalItem) {
        if ($scope.workerLotSelection.length > 1) {
          return $scope.workerLotSelection.length + " checked";
        } else {
          return itemText;
        }
      },
    };

    $scope.example5customTexts = {
      buttonDefaultText: "Lots",
    };

    $scope.selectionEvents = function () {
      if (this.lotSelection.length === 0) {
        if (this.lot_has_one) {
          this.lot_has_one = false;
          this.has_many = false;
          this.selectedLot = {};
        }
        return;
      }

      if (this.lotSelection.length === 1 && this.selectedPhase) {
        this.has_many = false;
        var lot = $filter("filter")(
          this.selectedPhase.lot,
          {
            name: this.lotSelection[0].lot,
          },
          true
        );

        if (lot.length === 1) this.selectedLot = lot[0];
        else this.selectedLot = {};
      } else {
        this.lot_has_one = false;
        this.has_many = true;
        return;
      }

      this.lot_has_one = true;
    };

    $scope.workerLotSelection = [];
    $scope.worker_lot_has_one = false;
    $scope.worker_has_many = false;

    $scope.workerSelectionEvents = function (idx) {
      if (!this.worker.workerLotSelection) {
        this.worker.workerLotSelection = [];
        this.worker.worker_lot_has_one = false;
        this.worker.worker_has_many = false;
      }

      if (this.worker.workerLotSelection.length === 0) {
        if (this.worker.worker_lot_has_one) {
          this.worker.worker_lot_has_one = false;
          this.worker.worker_has_many = false;
          this.worker.workerSelectedLot = {};
        }
        return;
      }

      if (this.worker.workerLotSelection.length === 1) {
        this.worker.has_many = false;
        if (!this.worker.selectedWorkerPhase) {
          this.worker.workerSelectedLot = {};
          return;
        }
        var lot = $filter("filter")(
          this.worker.selectedWorkerPhase.lot,
          {
            name: this.worker.workerLotSelection[0].lot,
          },
          true
        );

        if (lot.length === 1) this.worker.workerSelectedLot = lot[0];
        else this.worker.workerSelectedLot = {};
      } else {
        this.worker.worker_lot_has_one = false;
        this.worker.worker_has_many = true;
        return;
      }

      this.worker.worker_lot_has_one = true;
    };

    $scope.date = new Date();
    $scope.all_tasks = [];
    $scope.task_selector = [];
    $scope.foreman_tasks = [];
    $scope.foreman_total_hours = 0;
    $scope.foreman_total_bonus = 0;
    $scope.foreman_total_pay = 0;
    $scope.view = "tasks";
    $scope.submit_tasks = [];
    $scope.tradesmen = [];
    $scope.task_hours = [];
    $scope.current_foreman_id = 0;
    $scope.current_foremen = [];
    $scope.checked = true;
    $scope.holidays = [];
    var dateFormat = "yyyy-MM-dd";
    $scope.date_array = [];
    $scope.popup = {
      opened: false,
    };
    $scope.available_lots = [];
    $scope.is_admin = false;
    $scope.is_manager = false;
    $scope.is_foreman = false;
    $scope.users = [];
    $scope.selectedPhase = {};

    //$scope.tasks = [];
    $scope.my_trade_code = tradeCodeService.getCode($scope.user.trade[0]);

    $scope.today = function () {
      $scope.item = {
        override_date_completion: new Date(),
      };
    };
    $scope.today();

    $scope.clear = function () {
      $scope.item = {
        override_date_completion: null,
      };
    };

    // Disable weekend selection
    function disabled(data) {
      if (data.mode === "day") {
        if (
          $scope.holidays.indexOf($filter("date")(data.date, dateFormat)) !== -1
        ) {
          return 1;
        }
      }
      return (
        data.mode === "day" &&
        (data.date.getDay() === 0 || data.date.getDay() === 6)
      );
    }

    $scope.dateOptions = {
      //dateDisabled: disabled,
      //maxDate: new Date(),
      formatYear: "yy",
      startingDay: 0,
    };

    $scope.processProjectHours = function () {
      //code is a copy in forman controller file
      console.log("processProjectHours");
      //call processProjectHours on the server and pass user object in the request
      var start = moment().startOf("day");
      var end = moment().endOf("day");
      console.log(
        "getting start day",
        start.toString(),
        " and end day",
        end.toString()
      );
      // var start = moment()
      //     .set("year", 2017)
      //     .set("month", 0)
      //     .set("date", 1);
      // var end = moment().set("year", 2018).set("month", 6).set("date", 1);
      $http
        .get("/api/projectHoursProcess", {
          params: {
            username: $scope.user.username,
            roles: $scope.user.roles,
            mainusername: userService.getMainUsername($scope.user.username),
            start: start.toDate(),
            end: end.toDate(),
            trade: $scope.user.trade[0],
            company_code: $scope.user.contractor_code,
          },
        })
        .then(
          function (response) {
            console.log("processProjectHours complete");
            $scope.project_reports = response.data;
          },
          function (error) {
            console.log("processProjectHours error");
          }
        );
    };

    $scope.init = function () {
      $scope.startDate = new Date();
      $scope.endDate = new Date();

      $scope.startDate.setHours(0);
      $scope.startDate.setMinutes(0);
      $scope.startDate.setSeconds(0);
      $scope.endDate.setHours(23);
      $scope.endDate.setMinutes(59);
      $scope.endDate.setSeconds(59);

      $scope.activeOnly = {};
      $scope.activeOnly.on = true;

      $scope.user.roles.forEach(function (role) {
        if (role === "tm_admin") {
          $scope.is_admin = true;
          $scope.is_manager = true;
        } else if (role === "tm_office") {
          $scope.is_admin = true;
          $scope.is_manager = true;
        } else if (role === "tm") {
          $scope.is_manager = true;
        } else if (role === "foreman") {
          $scope.is_foreman = true;
        }
      });

      userService.getMainAccountId($scope.user.username).then(
        function (success) {
          $scope.main_id = success;
          Holidays.query({ main_account_id: success }, function (holidays) {
            if (holidays.length === 1) {
              _.each(holidays[0].entries, function (entry) {
                $scope.holidays.push($filter("date")(entry.date, dateFormat));
              });
            }
          });

          Trades.query({ main_account_id: $scope.main_id }, function (trade) {
            trade[0].company_code = aceUtils.padDigits(
              trade[0].company_code,
              3
            );
            trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
            $scope.trade = trade[0];

            $scope.require_passwords = trade[0].require_passwords;

            $scope.trade.production_bonus =
              $scope.trade.production_bonus || false;
            $scope.selectedPayPeriod = PayPeriodService.getCurrent(
              $scope.trade
            );

            if ($scope.selectedPayPeriod) {
              $scope.payStartDate = moment($scope.selectedPayPeriod.start);
              $scope.payEndDate = moment($scope.selectedPayPeriod.end);
              $scope.payToday = moment();

              Users.query(
                {
                  trade: $scope.user.trade[0],
                  active: true,
                  contractor_code: $scope.user.contractor_code,
                },
                function (users) {
                  _.each(users, function (user) {
                    if (user.roles[0] === "tm_admin") {
                      user.role = "Admin";
                    } else if (user.roles[0] === "tm_office") {
                      user.role = "Office";
                    } else if (user.roles[0] === "tm") {
                      user.role = "Manager";
                    } else if (user.roles[0] === "foreman") {
                      user.role = "Foreman";
                      $scope.users.push(user);
                    } else {
                      user.role = "Tradesman";
                      $scope.users.push(user);
                    }
                  });

                  Hours.query(
                    {
                      date: new Date(),
                      type: "NoPopulate",
                      trade_code: $scope.my_trade_code,
                      company_code: $scope.user.contractor_code,
                    },
                    function (hours) {
                      _.each(hours, function (hour) {
                        hour.date = new Date(hour.date);
                        if (hour.clock_in)
                          hour.clock_in.time = new Date(hour.clock_in.time);
                        if (hour.lunch_start)
                          hour.lunch_start.time = new Date(
                            hour.lunch_start.time
                          );
                        if (hour.lunch_end)
                          hour.lunch_end.time = new Date(hour.lunch_end.time);
                        if (hour.clock_out)
                          hour.clock_out.time = new Date(hour.clock_out.time);
                      });
                      $scope.clock_hours = hours;
                      $scope.foreman_hours = $filter("filter")(
                        hours,
                        { user: $scope.user._id },
                        true
                      )[0];

                      if ($scope.is_manager) {
                        $scope.view = "";
                        Users.query(
                          {
                            roles: "foreman",
                            trade: $scope.user.trade[0],
                            contractor_code: $scope.user.contractor_code,
                          },
                          function (users) {
                            $scope.current_foremen = users;
                          }
                        );
                      } else if ($scope.is_foreman) {
                        $scope.showSpinner = true;
                        $scope.current_foreman_id = $scope.user._id;
                        $scope.current_foreman_username = $scope.user.username;
                        $scope.selectedForeman = $scope.user;
                        // $scope.createUserTimecard($scope.selectedForeman, function(item) {
                        //     //$scope.current_timecards.push(item);
                        //     var idx = $scope.current_timecards.indexOf(item);
                        //     if(idx === -1) {
                        //         $scope.current_timecards.push(item);
                        //     } else {
                        //         $scope.current_timecards[idx] = item;
                        //     }
                        // });
                        $scope.getTasks();
                        //$scope.getProjectNames();
                      }
                    }
                  );
                }
              );

              // taskListService.getByTrade($scope.my_trade_code).then(function (tasks) {
              //     $scope.tasks = $filter('orderBy')(tasks, 'task_code');
              // });
            } else {
              toaster.pop(
                "error",
                "Pay Period Error",
                "Could not determine pay period. Contact admin."
              );
            }
          });
        },
        function (error) {
          toaster.pop(
            "error",
            "Holiday Admin Panel",
            "There was a problem with getting the holidays from the database"
          );
        }
      );
    };

    $scope.changeActive = function (activeOnly) {
      if (activeOnly.on === false) {
        $scope.activeOnly = {};
      }
    };

    $scope.changeForeman = function () {
      $scope.showSpinner = true;
      $scope.current_foreman_id = $scope.selectedForeman._id;
      $scope.current_foreman_username = $scope.selectedForeman.username;
      $scope.task_hours = [];
      $scope.all_tasks = [];
      $scope.task_selector = [];
      $scope.new_task_selector = [];
      $scope.foreman_tasks = [];
      $scope.tradesmen = [];
      $scope.formanTasks = [];
      //$scope.current_timecards = [];
      $scope.getTasks();
      // $scope.createUserTimecard($scope.selectedForeman, function(item) {
      //     //$scope.current_timecards.push(item);
      //     var idx = $scope.current_timecards.indexOf(item);
      //     if(idx === -1) {
      //         $scope.current_timecards.push(item);
      //     } else {
      //         $scope.current_timecards[idx] = item;
      //     }
      // });
      $scope.view = "tasks";
    };

    $scope.changePhase = function () {
      $scope.available_lots = [];
      $scope.formanTasks = [];

      this.selectedTaskCode = $scope.selectedTaskCode = {};

      if (!$scope.selectedPhase) return;

      $scope.selectedPhase.lots = _.remove(
        $scope.selectedPhase.lots,
        function (lot) {
          return !lot.complete;
        }
      );

      var lots = $filter("orderBy")($scope.selectedPhase.lot, "name");
      console.log("building");
      for (var i = 0; i < lots.length; i++) {
        $scope.available_lots.push({
          id: i,
          label: lots[i].name + " (" + lots[i].plan + ")",
          lot: lots[i].name,
        });

        for (var j = 0; j < lots[i].task_codes.length; j++) {
          var newTaskCode = $filter("filter")(
            $scope.formanTasks,
            {
              //     'task_code': lots[i].task_codes[j].name,
              //     'geoLocation': $scope.selectedJob.geoLocation,
              //     'projectType': $scope.selectedJob.projectType
              //  });
              // if(!newTaskCode.length) {
              //     var taskObj = $filter('filter')($scope.tasks, {
              //         'task_code': lots[i].task_codes[j].name,
              //         'geoLocation': $scope.selectedJob.geoLocation,
              //         'projectType': $scope.selectedJob.projectType
              //     });

              task_code: lots[i].task_codes[j].name,
            },
            true
          );
          if (!newTaskCode.length) {
            var taskObj = $filter("filter")(
              $scope.all_tasks,
              {
                task_code: lots[i].task_codes[j].name,
              },
              true
            );

            if (taskObj.length) {
              $scope.formanTasks.push(taskObj[0]);
            }
          }
        }
      }
    };

    $scope.changeWorkerPhase = function (worker) {
      worker.available_lots = [];
      $scope.workerTasks = [];
      this.worker.selectedWorkerTaskCode = $scope.selectedWorkerTaskCode = {};

      if (!this.worker.selectedWorkerPhase) return;

      this.worker.selectedWorkerPhase.lots = _.remove(
        this.worker.selectedWorkerPhase.lots,
        function (lot) {
          return !lot.complete;
        }
      );

      var lots = $filter("orderBy")(
        this.worker.selectedWorkerPhase.lot,
        "name"
      );

      lots.forEach(function (lot, ii) {
        worker.available_lots.push({
          id: ii,
          label: lot.name + " (" + lot.plan + ")",
          lot: lot.name,
        });
        for (var i = 0; i < lot.task_codes.length; i++) {
          var newTaskCode = $filter("filter")(
            $scope.workerTasks,
            {
              //     'task_code': lot.task_codes[j].name,
              //     'geoLocation': $scope.selectedJob.geoLocation,
              //     'projectType': $scope.selectedJob.projectType
              //  });
              // if(!newTaskCode.length) {
              //     var taskObj = $filter('filter')($scope.tasks, {
              //         'task_code': lot.task_codes[j].name,
              //         'geoLocation': $scope.selectedJob.geoLocation,
              //         'projectType': $scope.selectedJob.projectType
              //      });

              task_code: lot.task_codes[i].name,
            },
            true
          );
          if (!newTaskCode.length) {
            var taskObj = $filter("filter")(
              $scope.all_tasks,
              {
                task_code: lot.task_codes[i].name,
              },
              true
            );

            if (taskObj.length) {
              $scope.workerTasks.push(taskObj[0]);
            }
          }
        }
      });
    };

    $scope.addEmployeesFromPriorWorkDay = function () {
      var priorWorkDay = moment($scope.startDate).subtract(1, "day");

      while (foremanCalendarService.disabled(new Date(priorWorkDay), "day")) {
        priorWorkDay.subtract(1, "day");
      }

      var endDate = priorWorkDay.clone();

      endDate.hours(23);
      endDate.minutes(59);
      endDate.seconds(59);

      ProjectHours.query(
        {
          type: "dateRangeAndForemanIDPopulate",
          start: priorWorkDay.toDate(),
          end: endDate.toDate(),
          foreman_id: $scope.current_foreman_id,
        },
        function (hours_returned) {
          var hours = $filter("unique")(hours_returned, "username");

          _.each(hours, function (hour) {
            var user = $filter("filter")($scope.users, {
              username: hour.username,
            });

            if (
              user.length === 1 &&
              user[0]._id !== $scope.current_foreman_id
            ) {
              user = user[0];

              var check = $filter("filter")(
                $scope.tradesmen,
                {
                  username: user.username,
                },
                true
              );
              if (check.length > 0) {
                toaster.pop(
                  "warning",
                  "Add Tradesman Warning",
                  "Tradesman " + user.name + " is already in the list."
                );
              } else {
                $scope.tradesmen.push({
                  _id: user._id,
                  username: user.username,
                  name: user.name,
                  workerLotSelection: [],
                  pay_rate: user.pay_rate,
                  current_pay_rate: user.pay_rate,
                  total_hours: 0,
                  total_pay: 0,
                  foreman_total_bonus: 0,
                  tasks: [],
                });

                // $scope.createUserTimecard(user, function(item) {
                //     //$scope.current_timecards.push(item);
                //     var idx = $scope.current_timecards.indexOf(item);
                //     if(idx === -1) {
                //         $scope.current_timecards.push(item);
                //     } else {
                //         $scope.current_timecards[idx] = item;
                //     }
                // });
              }
            }
          });
        }
      );
    };

    $scope.getTasks = function () {
      ProjectHours.query(
        {
          type: "dateRangeAndForemanID",
          start: $scope.startDate,
          end: $scope.endDate,
          foreman_id: $scope.current_foreman_id,
        },
        function (task_hours) {
          $scope.task_hours = task_hours;

          ProjectTasks.query(
            {
              complete: false,
              type: "ForemanTaskSelector",
              "foreman.username": $scope.current_foreman_username,
            },
            function (tasks) {
              $scope.all_tasks = tasks;

              //$scope.all_tasks.forEach(function(task) {
              _.each($scope.all_tasks, function (task) {
                //if ($scope.is_foreman && task.foreman.username == $scope.user.username)

                if (task.task_code === "0510") {
                  // console.log(task.task_code + ' - ' + task.status);
                }

                task.name = task.division.name;
                var new_job_text = task.division.name;
                var in_task = $filter("filter")(
                  $scope.task_selector,
                  { job_text: new_job_text },
                  true
                );

                if (in_task.length === 0) {
                  //this is a new task number so add all the data
                  $scope.task_selector.push({
                    task_id: task._id,
                    job_text: task.division.name,
                    company_code: task.company_code,
                    trade_code: task.trade_code,
                    project_name: task.name,
                    job_code: task.job_code,
                    task_code: task.task_code,
                    geoLocation: task.project_id.geoLocation,
                    projectType: task.project_id.projectType,
                  });

                  //build task_selector for the view
                  var code = [];
                  code.push({
                    _id: task._id,
                    name: task.task_code,
                    finished: task.status,
                    full_name: task.task_name,
                  });

                  var lot = [];
                  lot.push({
                    name: task.lot,
                    plan: task.plan_code,
                    task_codes: code,
                  });

                  $scope.task_selector[$scope.task_selector.length - 1].phase =
                    [];
                  $scope.task_selector[
                    $scope.task_selector.length - 1
                  ].phase.push({
                    name: task.phase,
                    lot: lot,
                  });
                } else {
                  //we've already added this job_text to the list
                  //so we need to figure out if we need to add a phase or a lot
                  var found = false;
                  for (var i = 0; i < in_task[0].phase.length; i = i + 1) {
                    if (in_task[0].phase[i].name === task.phase) {
                      found = true;
                      var lot_found = false;
                      var lot_index = 0;
                      //we found the phase so lets see if we have this lot
                      for (
                        var j = 0;
                        j < in_task[0].phase[i].lot.length;
                        j = j + 1
                      ) {
                        if (in_task[0].phase[i].lot[j].name === task.lot) {
                          lot_found = true;
                          lot_index = j;
                        }
                      }

                      if (!lot_found) {
                        var code = [];
                        code.push({
                          _id: task._id,
                          name: task.task_code,
                          finished: task.status,
                          full_name: task.task_name,
                        });

                        in_task[0].phase[i].lot.push({
                          name: task.lot,
                          plan: task.plan_code,
                          task_codes: code,
                        });
                      } else {
                        var task_found = false;
                        for (
                          var k = 0;
                          k <
                          in_task[0].phase[i].lot[lot_index].task_codes.length;
                          k = k + 1
                        ) {
                          if (
                            in_task[0].phase[i].lot[lot_index].task_codes[k]
                              .name === task.task_codes
                          ) {
                            task_found = true;
                          }
                        }

                        if (!task_found) {
                          in_task[0].phase[i].lot[lot_index].task_codes.push({
                            _id: task._id,
                            name: task.task_code,
                            finished: task.status,
                            full_name: task.task_name,
                          });
                        }
                      }
                    }
                  }

                  if (!found) {
                    //the phase was not found so add the task_code, lot, and phase
                    var code = [];
                    code.push({
                      _id: task._id,
                      name: task.task_code,
                      finished: task.status,
                      full_name: task.task_name,
                    });

                    in_task[0].phase.push({
                      name: task.phase,
                      lot: [
                        {
                          name: task.lot,
                          plan: task.plan_code,
                          task_codes: code,
                        },
                      ],
                    });
                  }
                }

                var foreman_hours = $filter("filter")(
                  $scope.task_hours,
                  {
                    username: $scope.current_foreman_username,
                    project_task_id: task._id,
                  },
                  true
                );

                if (foreman_hours.length === 1) {
                  $scope.foreman_total_hours += foreman_hours[0].hours;
                  $scope.foreman_total_bonus +=
                    foreman_hours[0].production_bonus;
                  $scope.foreman_total_pay +=
                    foreman_hours[0].hours * foreman_hours[0].rate +
                    foreman_hours[0].production_bonus;

                  $scope.foreman_tasks.push({
                    company_code: task.company_code,
                    trade_code: task.trade_code,
                    job: task.job_code,
                    phase: task.phase,
                    project_name: task.name,
                    production_bonus: foreman_hours[0].production_bonus,
                    lot: task.lot,
                    task: task.task_code,
                    status: task.status,
                    hours_id: foreman_hours[0]._id,
                    hours: foreman_hours[0].hours,
                    notes: task.notes,
                    task_id: task._id,
                    project_id: task.project_id._id || task.project_id,
                    cost:
                      foreman_hours[0].hours * foreman_hours[0].rate +
                      foreman_hours[0].production_bonus,
                  });
                } else if (foreman_hours.length > 1) {
                  toaster.pop(
                    "error",
                    "foreman.js, line 427",
                    "Found too many foremen for this task id.  Call Admin."
                  );
                  return;
                }

                $scope.buildWorkerList(task, task.tradesman);
              });

              $scope.showSpinner = false;

              var trade_ids = [];
              trade_ids.push($scope.current_foreman_id);
              _.each($scope.tradesmen, function (user) {
                trade_ids.push(user._id);
              });

              // Timecards.query({'trade_code': userService.getTradeCode($scope.user.username),
              //     'company_code': $scope.user.contractor_code,
              //     'type': 'UserList',
              //     'users': trade_ids,
              //     'start_date': $scope.payStartDate.toDate(),
              //     'end_date': $scope.payEndDate.toDate() }, function(timecardDB) {
              //     console.log(timecardDB);

              //     //$scope.current_timecards = timecardDB;
              //     _.each(timecardDB, function(time) {
              //         //var idx = $scope.current_timecards.findIndex(x => x._id === time._id);
              //         var idx = $scope.current_timecards.indexOf(time);
              //         if(idx === -1) {
              //             console.log('adding to timecard list');
              //             $scope.current_timecards.push(time);
              //         }
              //     });
              // });
            }
          );
        }
      );
    };

    $scope.buildWorkerList = function (task, workers) {
      _.each(task.tradesman, function (worker) {
        var worker_hours = $filter("filter")(
          $scope.task_hours,
          { username: worker.username, project_task_id: task._id },
          true
        );

        _.each(worker_hours, function (worker_hour) {
          var my_worker = $filter("filter")(
            $scope.tradesmen,
            {
              username: worker.username,
            },
            true
          );
          if (!worker_hour.rate) {
            console.log("i dont have a rate");
            //for some reason we do not have a valid rate so let's get the users rate
            Users.query({ username: worker.username }, function (user) {
              //the task has a valid rate so lets use that
              if (my_worker.length === 0) {
                //need to add this worker to $scope.tradesmen
                var tmp_task = [];
                tmp_task.push({
                  company_code: task.company_code,
                  trade_code: task.trade_code,
                  job: task.job_code,
                  phase: task.phase,
                  lot: task.lot,
                  project_name: task.name,
                  task: task.task_code,
                  status: task.status,
                  notes: task.notes,
                  task_id: task._id,
                  project_id: task.project_id._id || task.project_id,
                  hours_id: worker_hour._id,
                  hours: worker_hour.hours,
                  cost: worker_hour.hours * user[0].pay_rate,
                  production_bonus: 0,
                });

                $scope.tradesmen.push({
                  _id: user._id,
                  username: worker.username,
                  name: worker.name,
                  phone: worker.phone,
                  email: worker.email,
                  total_hours: worker_hour.hours,
                  total_pay: worker_hour.hours * user[0].pay_rate,
                  pay_rate: user[0].pay_rate,
                  tasks: tmp_task,
                  foreman_total_bonus: 0,
                });
              } else if (my_worker.length === 1) {
                //I have this worker.  I need to update his task list and hours
                my_worker[0].total_hours += worker_hour.hours;
                my_worker[0].total_pay +=
                  worker_hour.hours * user[0].rate +
                  worker_hour.production_bonus;
                my_worker[0].foreman_total_bonus +=
                  worker_hour.production_bonus;
                my_worker[0].tasks.push({
                  company_code: task.company_code,
                  trade_code: task.trade_code,
                  job: task.job_code,
                  phase: task.phase,
                  lot: task.lot,
                  project_name: task.name,
                  task: task.task_code,
                  notes: task.notes,
                  task_id: task._id,
                  project_id: task.project_id._id || task.project_id,
                  production_bonus: 0,
                  status: task.status,
                  hours_id: worker_hour._id,
                  hours: worker_hour.hours,
                  cost: worker_hour.hours * user[0].rate,
                });
              } else {
                toaster.pop(
                  "error",
                  "foreman.js, line 488",
                  "Got too many workers back for the tradesmen.  Call admin!"
                );
                return;
              }

              //updated the ProjectHours with the missing rate
              worker_hour.rate = user[0].rate;
              worker_hour.$update(function (success) {
                success.user = success.user._id;
              });
            });
          } else {
            if (my_worker.length === 0) {
              //need to add this worker to $scope.tradesmen
              var tmp_task = [];
              var tmpProductionBonus = 0;
              tmp_task.push({
                company_code: task.company_code,
                trade_code: task.trade_code,
                job: task.job_code,
                phase: task.phase,
                lot: task.lot,
                project_name: task.name,
                task: task.task_code,
                notes: task.notes,
                task_id: task._id,
                project_id: task.project_id._id || task.project_id,
                status: task.status,
                hours_id: worker_hour._id,
                hours: worker_hour.hours,
                production_bonus: worker_hour.production_bonus,
                cost:
                  worker_hour.hours * worker_hour.rate +
                  worker_hour.production_bonus,
              });
              tmpProductionBonus += worker_hour.production_bonus;
              var curUser = $filter("filter")(
                $scope.users,
                { username: worker.username },
                true
              )[0];

              if (!curUser) {
                toaster.pop("error", "User Error", worker);
              }
              $scope.tradesmen.push({
                _id: curUser._id,
                username: worker.username,
                name: worker.name,
                phone: worker.phone,
                email: worker.email,
                total_hours: worker_hour.hours,
                total_pay:
                  worker_hour.hours * worker_hour.rate + tmpProductionBonus,
                pay_rate: worker_hour.rate,
                current_pay_rate: curUser.pay_rate,
                foreman_total_bonus: tmpProductionBonus,
                tasks: tmp_task,
              });
            } else if (my_worker.length === 1) {
              //I have this worker.  I need to update his task list and hours
              my_worker[0].total_hours += worker_hour.hours;
              my_worker[0].foreman_total_bonus += worker_hour.production_bonus;
              my_worker[0].total_pay +=
                worker_hour.hours * worker_hour.rate +
                worker_hour.production_bonus;

              my_worker[0].tasks.push({
                company_code: task.company_code,
                trade_code: task.trade_code,
                job: task.job_code,
                phase: task.phase,
                lot: task.lot,
                project_name: task.name,
                production_bonus: worker_hour.production_bonus,
                task: task.task_code,
                status: task.status,
                notes: task.notes,
                task_id: task._id,
                project_id: task.project_id._id || task.project_id,
                hours_id: worker_hour._id,
                hours: worker_hour.hours,
                cost:
                  worker_hour.hours * worker_hour.rate +
                  worker_hour.production_bonus,
              });
            } else {
              toaster.pop(
                "error",
                "foreman.js, line 545",
                "Got too many workers back for the tradesmen.  Call admin!"
              );
              return;
            }
          }
        });
      });
    };

    $scope.getWorkerTasks = function (worker, job_id) {
      var data = [];
      worker.all_tasks = [];
      ProjectTasks.query(
        {
          complete: false,
          project_id: job_id,
          "foreman.username": $scope.current_foreman_username,
        },
        function (tasks) {
          worker.all_tasks = tasks;

          worker.all_tasks.forEach(function (task, idx) {
            if ($scope.is_foreman) return;

            if (task.task_code === "0510") {
              // console.log(task.task_code + ' - ' + task.status);
            }

            task.name = task.division.name;
            var new_job_text = task.division.name;
            var in_task = $filter("filter")(
              data,
              { job_text: new_job_text },
              true
            );

            if (in_task.length === 0) {
              //this is a new task number so add all the data
              data.push({
                task_id: task._id,
                job_text: task.division.name,
                company_code: task.company_code,
                trade_code: task.trade_code,
                project_name: task.name,
                job_code: task.job_code,
                task_code: task.task_code,
              });

              //build task_selector for the view
              var code = [];
              code.push({
                _id: task._id,
                name: task.task_code,
                finished: task.status,
                full_name: task.task_name,
              });

              var lot = [];
              lot.push({
                name: task.lot,
                task_codes: code,
              });

              data[data.length - 1].phase = [];
              data[data.length - 1].phase.push({
                name: task.phase,
                lot: lot,
              });
            } else {
              //we've already added this job_text to the list
              //so we need to figure out if we need to add a phase or a lot
              var found = false;
              for (var i = 0; i < in_task[0].phase.length; i = i + 1) {
                if (in_task[0].phase[i].name === task.phase) {
                  found = true;
                  var lot_found = false;
                  var lot_index = 0;
                  //we found the phase so lets see if we have this lot
                  for (
                    var j = 0;
                    j < in_task[0].phase[i].lot.length;
                    j = j + 1
                  ) {
                    if (in_task[0].phase[i].lot[j].name === task.lot) {
                      lot_found = true;
                      lot_index = j;
                    }
                  }

                  if (!lot_found) {
                    var code = [];
                    code.push({
                      _id: task._id,
                      name: task.task_code,
                      finished: task.status,
                      full_name: task.task_name,
                    });

                    in_task[0].phase[i].lot.push({
                      name: task.lot,
                      task_codes: code,
                    });
                  } else {
                    var task_found = false;
                    for (
                      var k = 0;
                      k < in_task[0].phase[i].lot[lot_index].task_codes.length;
                      k = k + 1
                    ) {
                      if (
                        in_task[0].phase[i].lot[lot_index].task_codes[k]
                          .name === task.task_codes
                      ) {
                        task_found = true;
                      }
                    }

                    if (!task_found) {
                      in_task[0].phase[i].lot[lot_index].task_codes.push({
                        _id: task._id,
                        name: task.task_code,
                        finished: task.status,
                        full_name: task.task_name,
                      });
                    }
                  }
                }
              }

              if (!found) {
                //the phase was not found so add the task_code, lot, and phase
                var code = [];
                code.push({
                  _id: task._id,
                  name: task.task_code,
                  finished: task.status,
                  full_name: task.task_name,
                });

                in_task[0].phase.push({
                  name: task.phase,
                  lot: [
                    {
                      name: task.lot,
                      task_codes: code,
                    },
                  ],
                });
              }
            }
          });
          worker.selectedWorkerJob = data[0];
          worker.selectedWorkerJob.name = data[0].job_text;
          //$scope.selectedJob = $scope.task_selector[0];
          //$scope.selectedJob.name = $scope.selectedJob.job_text;
        }
      );
    };

    $scope.changeTaskCode = function (item) {
      if (!item) return;
      $scope.selectedTaskCode = item;

      //item.name is valid when one lot is selected but not
      //when we have multiple lot selections.
      if (angular.isUndefined(item.name)) item.name = item.task_code;

      $scope.selectedTaskCode.remaining = 0;
      $scope.selectedTaskCode.remaining_updated = false;
      var task_list = [];

      var singleSelect = this.lotSelection.length == 1;

      //selectedJob, selectedPhase, selectedLot
      _.each(this.lotSelection, function (lot) {
        var bid_hours = $filter("filter")(
          $scope.all_tasks,
          {
            trade_code: $scope.selectedJob.trade_code,
            company_code: $scope.selectedJob.company_code,
            job_code: $scope.selectedJob.job_code,
            phase: $scope.selectedPhase.name,
            lot: lot.lot,
            task_code: singleSelect ? item.name : item.task_code,
          },
          true
        );
        if (bid_hours.length === 1) {
          if ($scope.trade.production_bonus) {
            $scope.selectedTaskCode.remaining -=
              bid_hours[0].actual_labor_costs;
          } else {
            $scope.selectedTaskCode.remaining += bid_hours[0].bid_hours;
          }
          if (task_list.indexOf(bid_hours[0]._id) === -1) {
            task_list.push(bid_hours[0]._id);
          }
        }
      });

      ProjectHours.query(
        { type: "HourTotalForTasks", tasks: task_list },
        function (ret_obj) {
          if (!$scope.trade.production_bonus) {
            $scope.selectedTaskCode.remaining -= ret_obj[0].total;
          }
          $scope.selectedTaskCode.remaining_updated = true;
        }
      );
    };

    $scope.changeWorkerTaskCode = function (item) {
      //var item = item.selectedWorkerTaskCode;
      if (!item) return;

      $scope.selectedWorkerTaskCode = item;

      $scope.selectedWorkerTaskCode.remaining = 0;
      $scope.selectedWorkerTaskCode.remaining_updated = false;

      //item.name is valid when one lot is selected but not
      //when we have multiple lot selections.
      if (angular.isUndefined(item.name)) item.name = item.task_code;

      var job = this.worker.selectedWorkerJob;
      var phase = this.worker.selectedWorkerPhase;
      var task_list = [];

      var singleSelect = this.worker.workerLotSelection.length == 1;

      _.each(this.worker.workerLotSelection, function (lot) {
        var bid_hours = $filter("filter")(
          $scope.all_tasks,
          {
            trade_code: job.trade_code,
            company_code: job.company_code,
            job_code: job.job_code,
            phase: phase.name,
            lot: lot.lot,
            task_code: singleSelect ? item.name : item.task_code,
          },
          true
        );

        if (bid_hours.length === 1) {
          if ($scope.trade.production_bonus) {
            $scope.selectedWorkerTaskCode.remaining -=
              bid_hours[0].actual_labor_costs;
          } else {
            $scope.selectedWorkerTaskCode.remaining += bid_hours[0].bid_hours;
          }

          if (task_list.indexOf(bid_hours[0]._id) === -1) {
            task_list.push(bid_hours[0]._id);
          }
        }
      });

      ProjectHours.query(
        { type: "HourTotalForTasks", tasks: task_list },
        function (ret_obj) {
          if (!$scope.trade.production_bonus) {
            $scope.selectedWorkerTaskCode.remaining -= ret_obj[0].total;
          }
          $scope.selectedWorkerTaskCode.remaining_updated = true;
        }
      );
    };

    $scope.AddForemanTask = function () {
      if (!$scope.selectedJob || !$scope.selectedPhase) {
        toaster.pop(
          "error",
          "foreman.js, line 617",
          "Job and/or phase is not selected, please try again."
        );
        return;
      }

      if ($scope.lotSelection.length === 0) {
        toaster.pop(
          "error",
          "foreman.js, line 623",
          "At least one lot must be selected"
        );
        return;
      }

      if (!$scope.selectedTaskCode) {
        toaster.pop(
          "error",
          "foreman.js, line 629",
          "A task must be selected.  Please reselect and try again"
        );
        return;
      }

      var total_lots = $scope.lotSelection.length;
      //remove lot/tasks that are already finished;
      Object.assign($scope.lotSelection).forEach(function (lot, index) {
        var lot_list = $filter("filter")(
          $scope.selectedPhase.lot,
          {
            name: lot.lot,
          },
          true
        );
        if (lot_list.length !== 1) {
          toaster.pop("error", "Lot List Error");
        } else {
          var task = $filter("filter")(
            lot_list[0].task_codes,
            {
              name: $scope.selectedTaskCode.task_code
                ? $scope.selectedTaskCode.task_code
                : $scope.selectedTaskCode.name,
            },
            true
          );

          if (task.length !== 1) {
            toaster.pop("error", "Task List Error");
          } else {
            if (task[0].finished === "finished") {
              $scope.lotSelection.splice(index, 1);
              total_lots = total_lots - 1;
            }
          }
        }
      });

      var tc_hours = angular.copy($scope.hours);

      if (total_lots === 0) {
        $scope.lot_has_one = false;
        $scope.has_many = false;
        $scope.bonus = "";

        this.selectedJob =
          this.selectedPhase =
          this.selectedLot =
          this.selectedTaskCode =
          this.hours =
          this.cost =
            "";
        $scope.lotSelection = [];
        toaster.pop(
          "error",
          "foreman.js, line 650",
          "This task is already completed."
        );
        return;
      }

      //$scope.addLaborHoursToTimecard($scope.selectedForeman, tc_hours);
      $scope.hours_to_save = [];
      $scope.hours = $scope.hours / total_lots;

      // calculate production bonus for task
      var productionBonus =
        ($scope.trade.production_bonus &&
          Number($scope.bonus) > 0 &&
          Number($scope.bonus) / total_lots) ||
        0;

      var singleSelect = $scope.lotSelection.length == 1;
      for (var i = 0; i < $scope.lotSelection.length; i++) {
        if (!$scope.selectedLot) $scope.selectedLot = {};

        var task = $filter("filter")(
          $scope.all_tasks,
          {
            company_code: $scope.selectedJob.company_code,
            trade_code: $scope.selectedJob.trade_code,
            job_code: $scope.selectedJob.job_code,
            lot: $scope.lotSelection[i].lot,
            phase: $scope.selectedPhase.name,
            task_code: singleSelect
              ? $scope.selectedTaskCode.name
              : $scope.selectedTaskCode.task_code,
          },
          true
        );

        if (task.length !== 1) {
          toaster.pop(
            "error",
            "foreman.js, line 650",
            "AddForemanTask returned more than one task.  Call admin"
          );
          return;
        }

        if (task[0].status !== "finished") {
          var check = $filter("filter")(
            $scope.foreman_tasks,
            {
              company_code: $scope.selectedJob.company_code,
              trade_code: $scope.selectedJob.trade_code,
              job: $scope.selectedJob.job_code,
              phase: $scope.selectedPhase.name,
              lot: $scope.lotSelection[i].lot,
              task: singleSelect
                ? $scope.selectedTaskCode.name
                : $scope.selectedTaskCode.task_code,
            },
            true
          );

          if (check.length !== 0) {
            toaster.pop(
              "error",
              "foreman.js, line 665",
              "Task is already in list."
            );
            return;
          }

          if (!$scope.hours) $scope.hours = 0;

          var pay = 0;
          if ($scope.is_manager) {
            pay = $scope.selectedForeman.pay_rate;
          } else {
            pay = $scope.user.pay_rate;
          }

          var saved_hours = new ProjectHours({
            name: $scope.selectedForeman.name,
            username: $scope.current_foreman_username,
            job_code: $scope.selectedJob.job_code,
            company_code: $scope.selectedJob.company_code,
            hours: $scope.hours,
            rate: pay,
            pay_total: $scope.hours * pay + productionBonus,
            production_bonus: productionBonus,
            date: new Date(),
            project_task_id: task[0]._id,
            project_id: task[0].project_id,
            foreman_id: $scope.current_foreman_id,
            trade: $scope.user.trade[0],
            notes: {
              comment: "Added " + $scope.hours + " hours for foreman.",
              date: new Date(),
              username: $scope.current_foreman_username,
            },
          });

          $scope.project_name_to_save = $scope.selectedJob.project_name;
          $scope.hours_to_save.push(saved_hours);
        }
      }

      $scope.showSpinner = true;
      $scope.saveHourRecords();

      $scope.lot_has_one = false;
      $scope.has_many = false;
      $scope.bonus = "";

      this.selectedJob =
        this.selectedPhase =
        this.selectedLot =
        this.selectedTaskCode =
        this.hours =
        this.cost =
          "";
      $scope.lotSelection = [];
    };

    $scope.saveHourRecords = function () {
      var hour = $scope.hours_to_save.pop();
      var pay = 0;
      if ($scope.is_manager) {
        pay = $scope.selectedForeman.pay_rate;
      } else {
        pay = $scope.user.pay_rate;
      }

      if (hour) {
        hour.$save(function (saved) {
          var task = $filter("filter")(
            $scope.all_tasks,
            {
              _id: saved.project_task_id,
            },
            true
          );

          if (task.length !== 1) {
            toaster.pop(
              "error",
              "foreman.js, line 706",
              "issue getting task after saving project hours"
            );
            return;
          }

          task = task[0];

          task.notes.push({
            comment: "Added " + saved.hours + " hours for foreman.",
            date: new Date(),
            username: $scope.current_foreman_username,
          });

          task.actual_man_hours += saved.hours;
          task.actual_labor_costs += saved.hours * pay + saved.production_bonus;
          task.foreman.hours = saved.hours;
          $scope.foreman_total_hours += saved.hours;
          $scope.foreman_total_bonus += saved.production_bonus;
          $scope.foreman_total_pay +=
            saved.hours * pay + saved.production_bonus;

          $scope.foreman_tasks.push({
            company_code: task.company_code,
            trade_code: task.trade_code,
            job: task.job_code,
            project_name: $scope.project_name_to_save,
            phase: task.phase,
            lot: task.lot,
            task: task.task_code,
            notes: task.notes,
            task_id: task._id,
            project_id: task.project_id._id || task.project_id,
            status: task.status,
            hours_id: saved._id,
            hours: saved.hours,
            cost: saved.hours * pay + saved.production_bonus,
            production_bonus: saved.production_bonus,
          });

          $scope.foreman_tasks[$scope.foreman_tasks.length - 1].hours_id =
            saved._id;
          $scope.task_hours.push(saved);

          task.foreman.rate = pay;
          task.$update();
          if ($scope.hours_to_save.length === 0) {
            $scope.showSpinner = false;
          } else {
            $timeout($scope.saveHourRecords, 50);
          }
        });
      } else {
        toaster.pop(
          "error",
          "Save Project Hours Error",
          "saveHourRecords was called but could not pull the " +
            "data. Contact Admin."
        );
        $scope.showSpinner = false;
      }
    };

    $scope.deleteForemanTask = function (index) {
      //var tmptask = $filter('filter')($scope.all_tasks, { 'task_code': $scope.foreman_tasks[index].task
      //  }, true);
      var task = $filter("filter")(
        $scope.all_tasks,
        {
          company_code: $scope.foreman_tasks[index].company_code,
          trade_code: $scope.foreman_tasks[index].trade_code,
          job_code: $scope.foreman_tasks[index].job,
          lot: $scope.foreman_tasks[index].lot,
          phase: $scope.foreman_tasks[index].phase,
          task_code: $scope.foreman_tasks[index].task,
        },
        true
      );

      var pay = 0;
      if ($scope.is_manager) {
        pay = $scope.selectedForeman.pay_rate;
      } else {
        pay = $scope.user.pay_rate;
      }

      //$scope.removeLaborHoursFromTimecard($scope.selectedForeman, $scope.foreman_tasks[index].hours);

      //update totals for the view
      $scope.foreman_total_hours -= $scope.foreman_tasks[index].hours;
      $scope.foreman_total_bonus -=
        $scope.foreman_tasks[index].production_bonus;
      $scope.foreman_total_pay -=
        $scope.foreman_tasks[index].hours * pay +
        $scope.foreman_tasks[index].production_bonus;

      task[0].notes.push({
        comment:
          "Removed " +
          $scope.foreman_tasks[index].hours +
          " hours for foreman.",
        date: new Date(),
        username: $scope.current_foreman_username,
      });

      var hours = $filter("filter")(
        $scope.task_hours,
        {
          username: $scope.current_foreman_username,
          project_task_id: task[0]._id,
        },
        true
      );

      if (hours.length === 1) {
        ProjectHours.query(
          { _id: hours[0]._id, complete: false },
          function (pHour) {
            if (pHour.length !== 1) {
              toaster.pop(
                "error",
                "foreman.js, line 794",
                "There is an issue with the hours database tracking.  Contact Admin."
              );
              return;
            }
            pHour[0].$delete();
            $scope.task_hours = $scope.task_hours.filter(
              (t_hours) => t_hours._id !== hours[0]._id
            );
          }
        );
      } else if (hours.length > 1) {
        toaster.pop(
          "error",
          "foreman.js, line 801",
          "Too many hour tasks returned from the system.  Call Admin."
        );
        return;
      }

      //update task totals and update the task
      task[0].actual_man_hours -= $scope.foreman_tasks[index].hours;
      task[0].actual_labor_costs -=
        $scope.foreman_tasks[index].hours * pay +
        $scope.foreman_tasks[index].production_bonus;
      task[0].foreman.hours = 0;
      task[0].$update();
      //remove from the task list view
      $scope.foreman_tasks.splice(index, 1);

      // remove Hours
      if (hours.length === 1) {
        var hoursIndex = $scope.task_hours.findIndex(
          (item) => item._id === hours[0]._id
        );
        $scope.task_hours.splice(hoursIndex, 1);
      }
    };

    $scope.addEmployee = function () {
      if (!$scope.selectedWorkerAdd) {
        toaster.pop(
          "error",
          "Worker Selection Error",
          "You must specify an employee to add."
        );
        return;
      }
      var user = $scope.selectedWorkerAdd;

      var check = $filter("filter")(
        $scope.tradesmen,
        {
          username: user.username,
        },
        true
      );
      if (check.length > 0) {
        toaster.pop(
          "error",
          "Add Tradesman Error",
          "Tradesman " + $scope.selectedWorkerAdd.name + " is already added."
        );
        return;
      }

      $scope.tradesmen.push({
        _id: user._id,
        username: user.username,
        name: user.name,
        workerLotSelection: [],
        pay_rate: user.pay_rate,
        current_pay_rate: user.pay_rate,
        total_hours: 0,
        total_pay: 0,
        foreman_total_bonus: 0,
        tasks: [],
      });

      // $scope.createUserTimecard(user, function(item) {
      //     //$scope.current_timecards.push(item);
      //     var idx = $scope.current_timecards.indexOf(item);
      //     if(idx === -1) {
      //         $scope.current_timecards.push(item);
      //     } else {
      //         $scope.current_timecards[idx] = item;
      //     }
      // });

      //clear the input field
      $scope.selectedWorkerAdd = {};
    };

    $scope.deleteWorkerTask = function (worker, index) {
      var task = $filter("filter")(
        $scope.all_tasks,
        {
          company_code: $scope.tradesmen[worker].tasks[index].company_code,
          trade_code: $scope.tradesmen[worker].tasks[index].trade_code,
          job_code: $scope.tradesmen[worker].tasks[index].job,
          lot: $scope.tradesmen[worker].tasks[index].lot,
          phase: $scope.tradesmen[worker].tasks[index].phase,
          task_code: $scope.tradesmen[worker].tasks[index].task,
        },
        true
      );

      if (task.length !== 1) {
        toaster.pop(
          "error",
          "foreman.js, line 856",
          "There is a problem deleting this workers task.  Contact Admin."
        );
        return;
      }

      var user = $filter("filter")(
        $scope.users,
        {
          username: $scope.tradesmen[worker].username,
        },
        true
      );

      if (user.length !== 1) {
        toaster.pop(
          "error",
          "User Error",
          "Problem with getting the tradesman user from the tradesmen list.  Call admin."
        );
        return;
      }

      //$scope.removeLaborHoursFromTimecard(user[0], $scope.tradesmen[worker].tasks[index].hours);

      //update totals for the view
      $scope.tradesmen[worker].total_hours -=
        $scope.tradesmen[worker].tasks[index].hours;
      $scope.tradesmen[worker].total_pay -=
        $scope.tradesmen[worker].tasks[index].hours *
          $scope.tradesmen[worker].pay_rate +
        $scope.tradesmen[worker].tasks[index].production_bonus;
      $scope.tradesmen[worker].foreman_total_bonus -=
        $scope.tradesmen[worker].tasks[index].production_bonus;

      task[0].notes.push({
        comment:
          "Removed " +
          $scope.tradesmen[worker].tasks[index].hours +
          " hours for tradesman " +
          $scope.tradesmen[worker].username +
          ".",
        date: new Date(),
        username: $scope.current_foreman_username,
      });

      var hours = $filter("filter")(
        $scope.task_hours,
        {
          username: $scope.tradesmen[worker].username,
          project_task_id: task[0]._id,
          hours: $scope.tradesmen[worker].tasks[index].hours,
        },
        true
      );

      if (hours.length === 1) {
        ProjectHours.query(
          { _id: hours[0]._id, complete: false },
          function (pHour) {
            if (pHour.length !== 1) {
              toaster.pop(
                "error",
                "foreman.js, line 878",
                "There is an issue with the hours database tracking.  Contact Admin."
              );
              return;
            }
            pHour[0].$delete();
            $scope.task_hours = $scope.task_hours.filter(
              (t_hours) => t_hours._id !== hours[0]._id
            );
          }
        );
      } else if (hours.length > 1) {
        toaster.pop(
          "error",
          "foreman.js, line 885",
          "Too many hour tasks returned from the system.  Call Admin."
        );
        return;
      }

      //update task totals and update the task
      task[0].actual_man_hours -= $scope.tradesmen[worker].tasks[index].hours;
      task[0].actual_labor_costs -=
        $scope.tradesmen[worker].tasks[index].hours *
          $scope.tradesmen[worker].pay_rate +
        $scope.tradesmen[worker].tasks[index].production_bonus;

      task[0].$update();
      //remove from the task list view
      $scope.tradesmen[worker].tasks.splice(index, 1);

      // remove Hours
      if (hours.length === 1) {
        var hoursIndex = $scope.task_hours.findIndex(
          (item) => item._id === hours[0]._id
        );
        $scope.task_hours.splice(hoursIndex, 1);
      }
    };

    // $scope.changeWorkerTaskCode = function(item) {
    // 	$scope.selectedWorkerTaskCode = item;
    // };

    $scope.addWorkerTask = function (
      index,
      job,
      phase,
      lot,
      task,
      hours,
      bonus
    ) {
      if (!job || !phase) {
        toaster.pop(
          "error",
          "Selection Error",
          "Job and/or phase is not selected, please try again."
        );
        return;
      }

      if (lot.length === 0) {
        toaster.pop(
          "error",
          "Selection Error",
          "At least one lot must be selected"
        );
        return;
      }

      if (!task) {
        toaster.pop(
          "error",
          "Selection Error",
          "A task must be selected.  Please reselect and try again"
        );
        return;
      }

      if (!hours) hours = 0;

      var total_lots = lot.length;

      //remove lot/tasks that are already finished;
      Object.assign(lot).forEach(function (item, index) {
        var lot_list = $filter("filter")(phase.lot, { name: item.lot }, true);
        if (lot_list.length !== 1) {
          toaster.pop("error", "Lot List Error");
        } else {
          var in_list = $filter("filter")(
            lot_list[0].task_codes,
            {
              name: task.task_code ? task.task_code : task.name,
            },
            true
          );
          if (in_list.length !== 1) {
            toaster.pop("error", "Task List Error");
          } else {
            if (in_list[0].finished === "finished") {
              lot.splice(index, 1);
              total_lots = total_lots - 1;
            }
          }
        }
      });

      var tc_hours = angular.copy(hours);
      var user_hours = $filter("filter")(
        $scope.users,
        {
          username: $scope.tradesmen[index].username,
        },
        true
      );

      if (user_hours.length !== 1) {
        toaster.pop(
          "error",
          "User Error",
          "Problem with getting the tradesman user from the tradesmen list.  Call admin."
        );
        return;
      }

      //$scope.addLaborHoursToTimecard(user_hours[0], tc_hours);

      if (total_lots === 0) {
        toaster.pop(
          "error",
          "foreman.js, line 650",
          "This task is already completed."
        );
        return;
      }

      hours = hours / total_lots;
      var workerProductionBonus =
        ($scope.trade.production_bonus &&
          Number(bonus) > 0 &&
          Number(bonus) / total_lots) ||
        0;
      $scope.tradesmen[index]["bonus"] = "";
      $scope.worker_hours_to_save = [];

      var singleSelect = lot.length == 1;
      for (var i = 0; i < lot.length; i++) {
        var inlist = $filter("filter")(
          $scope.all_tasks,
          {
            company_code: job.company_code,
            trade_code: job.trade_code,
            job_code: job.job_code,
            lot: lot[i].lot,
            phase: phase.name,
            task_code: singleSelect ? task.name : task.task_code,
          },
          true
        );

        if (inlist.length !== 1) {
          this.worker.selectedWorkerJob =
            this.worker.selectedWorkerPhase =
            this.worker.workerLotSelection =
            this.worker.selectedWorkerTaskCode =
            this.worker.hours =
            this.worker.selectedWorkerProject =
              "";
          toaster.pop(
            "error",
            "foreman.js, line 939",
            "addWorkerTask returned more than one task.  Call admin"
          );
          return;
        }

        if (inlist[0].status !== "finished") {
          var user = $filter("filter")(
            $scope.tradesmen,
            {
              username: $scope.tradesmen[index].username,
            },
            true
          );

          if (user.length !== 1) {
            toaster.pop(
              "error",
              "User Error",
              "Problem with getting the tradesman user from the tradesmen list.  Call admin."
            );
            return;
          }

          var check = $filter("filter")(
            user[0].tasks,
            {
              company_code: job.company_code,
              trade_code: job.trade_code,
              job: job.job_code,
              phase: phase.name,
              lot: lot[i].lot,
              task: singleSelect ? task.name : task.task_code,
            },
            true
          );

          if (check.length !== 0) {
            toaster.pop(
              "error",
              "foreman.js, line 944",
              "Task is already in list."
            );
            return;
          }

          var updatedUser = $filter("filter")(
            $scope.users,
            {
              username: $scope.tradesmen[index].username,
            },
            true
          );

          var pay_rate = user[0].pay_rate;

          if (updatedUser.length !== 1) {
            toaster.pop(
              "error",
              "User Error",
              "Problem with getting the tradesman user from the tradesmen list.  Call admin."
            );
            return;
          } else {
            pay_rate = updatedUser[0].pay_rate;
          }

          var saved_hours = new ProjectHours({
            name: user[0].name,
            username: user[0].username,
            job_code: job.job_code,
            company_code: job.company_code,
            hours: hours,
            rate: pay_rate,
            pay_total: pay_rate * hours + workerProductionBonus,
            production_bonus: workerProductionBonus,
            date: new Date(),
            project_task_id: inlist[0]._id,
            project_id: inlist[0].project_id,
            foreman_id: $scope.current_foreman_id,
            trade: $scope.user.trade[0],
            notes: {
              comment: "Added " + hours + " hours.",
              date: new Date(),
              username: $scope.current_foreman_username,
            },
          });

          $scope.project_name_to_save = job.project_name;
          $scope.worker_hours_to_save.push(saved_hours);
        }
      }

      $scope.showSpinner = true;
      $scope.saveWorkerHourRecords(index, user);

      this.worker.selectedWorkerJob =
        this.worker.selectedWorkerPhase =
        this.worker.workerLotSelection =
        this.worker.selectedWorkerTaskCode =
        this.worker.hours =
        this.worker.selectedWorkerProject =
          "";
    };

    $scope.saveWorkerHourRecords = function (index, user) {
      var hour = $scope.worker_hours_to_save.pop();

      if (hour) {
        hour.$save(function (saved) {
          var worker = $scope.tradesmen[index];
          var task = $filter("filter")(
            $scope.all_tasks,
            {
              _id: saved.project_task_id,
            },
            true
          );

          if (task.length !== 1) {
            toaster.pop(
              "error",
              "foreman.js, line 975",
              "issue getting task after saving project hours"
            );
            return;
          }

          task = task[0];

          task.notes.push({
            comment:
              "Added " +
              saved.hours +
              " hours for tradesman " +
              user[0].username +
              ".",
            date: new Date(),
            username: $scope.current_foreman_username,
          });

          var rate = saved.rate;

          task.actual_man_hours += saved.hours;
          task.actual_labor_costs +=
            saved.hours * rate + saved.production_bonus;
          var worker = $filter("filter")(
            task.tradesman,
            {
              username: $scope.tradesmen[index].username,
            },
            true
          );
          if (worker.length === 0) {
            task.tradesman.push({
              name: user[0].name,
              username: user[0].username,
              phone: user[0].phone,
              email: user[0].email,
              hours: saved.hours,
              rate: rate,
            });
          } else if (worker.length === 1) {
            worker[0].hours += saved.hours;
          } else {
            toaster.pop(
              "error",
              "foreman.js, line 1007",
              "Too many tradesmen returned for this task.  Call admin"
            );
            return;
          }

          user[0].total_hours += saved.hours;
          user[0].total_pay += saved.hours * rate + saved.production_bonus;
          user[0].foreman_total_bonus += saved.production_bonus;
          user[0].tasks.push({
            hours_id: saved._id,
            company_code: task.company_code,
            trade_code: task.trade_code,
            job: task.job_code,
            phase: task.phase,
            project_name: $scope.project_name_to_save,
            project_task_id: task._id,
            lot: task.lot,
            task: task.task_code,
            status: task.status,
            notes: task.notes,
            task_id: task._id,
            project_id: task.project_id._id || task.project_id,
            hours: saved.hours,
            cost: saved.hours * rate + saved.production_bonus,
            production_bonus: saved.production_bonus,
          });

          $scope.task_hours.push(saved);
          task.$update();
          if ($scope.worker_hours_to_save.length === 0) {
            $scope.showSpinner = false;
          } else {
            $timeout(function () {
              $scope.saveWorkerHourRecords(index, user);
            }, 50);
          }
        });
      } else {
        toaster.pop(
          "error",
          "Save Project Hours Error",
          "saveWorkerHourRecords was called but could not pull the " +
            "data. Contact Admin."
        );
        $scope.showSpinner = false;
      }
    };

    $scope.submit = function () {
      $scope.view = "summary";
      $scope.submit_tasks = [];
      //$scope.submit_hours = [];

      for (var i = 0; i < $scope.foreman_tasks.length; i++) {
        var ftask = $scope.foreman_tasks[i];
        var task = $filter("filter")(
          $scope.submit_tasks,
          {
            company_code: ftask.company_code,
            trade_code: ftask.trade_code,
            job: ftask.job,
            lot: ftask.lot,
            phase: ftask.phase,
            task_code: ftask.task,
          },
          true
        );

        if (task.length === 0) {
          //this task is not found so just add it
          $scope.submit_tasks.push(angular.copy(ftask));
        } else {
          task.forEach(function (tmp) {
            //we have this task so lets increment the hours/cost
            tmp.hours = ftask.hours + tmp.hours;
            tmp.cost = ftask.cost + tmp.cost;
            tmp.production_bonus =
              ftask.production_bonus + tmp.production_bonus;
          });
        }
      }

      for (var i = 0; i < $scope.tradesmen.length; i++) {
        var trade = $scope.tradesmen[i];
        for (var j = 0; j < trade.tasks.length; j++) {
          var ttask = trade.tasks[j];
          var task = $filter("filter")(
            $scope.submit_tasks,
            {
              company_code: ttask.company_code,
              trade_code: ttask.trade_code,
              job: ttask.job,
              lot: ttask.lot,
              phase: ttask.phase,
              task: ttask.task,
            },
            true
          );

          if (task.length === 0) {
            //this task is not found so just add it
            $scope.submit_tasks.push(angular.copy(ttask));
          } else {
            for (var k = 0; k < task.length; k++) {
              var tmp = task[k];
              //we have this task so lets increment the hours/cost
              tmp.hours = ttask.hours + tmp.hours;
              tmp.cost = ttask.cost + tmp.cost;
              tmp.production_bonus =
                ttask.production_bonus + tmp.production_bonus;
            }
          }
        }
      }
    };

    $rootScope.$on(
      "$stateChangeStart",
      function (event, toState, toParams, fromState, fromParams) {
        if (
          fromState.url === "/foreman/daily/report" &&
          $scope.view === "summary"
        ) {
          event.preventDefault();
          var notes = $scope.submit_tasks.filter(function (item) {
            return item.note;
          });

          if (notes.length) {
            ngDialog
              .openConfirm({
                template:
                  "<h2 >Save Note</h2>" +
                  "<p>Are you sure you want to go back without saving note? </p>" +
                  '<div style="text-align:center" >' +
                  '<button type="button" class="btn btn-default" style="margin-right:15px" ng-click="closeThisDialog(0)">No</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(2)">Yes</button>' +
                  "</div>",
                plain: true,
                className: "ngdialog-theme-default ngdialog-sm",
              })
              .then(function (value) {
                if (value) {
                  $window.location.href = toState.url;
                }
              });
          } else {
            $window.location.href = toState.url;
          }
        }
      }
    );

    $scope.back = function () {
      var notes = $scope.submit_tasks.filter(function (item) {
        return item.note;
      });

      if (notes.length) {
        ngDialog
          .openConfirm({
            template:
              "<h2 >Save Note</h2>" +
              "<p>Are you sure you want to go back without saving note? </p>" +
              '<div style="text-align:center" >' +
              '<button type="button" class="btn btn-default" style="margin-right:15px" ng-click="closeThisDialog(0)">No</button>' +
              '<button type="button" class="btn btn-primary" ng-click="confirm(2)">Yes</button>' +
              "</div>",
            plain: true,
            className: "ngdialog-theme-default ngdialog-sm",
          })
          .then(function (value) {
            if (value) {
              $scope.view = "tasks";
            }
          });
      } else {
        $scope.view = "tasks";
      }
    };

    $scope.finalSubmit = function () {
      $scope.finalSubmitChecker = true;
      var hours = $scope.getWorkerHours($scope.selectedForeman);
      $scope.foremanClockOut($scope.selectedForeman, hours);
    };

    $scope.updateProjectHours = function () {
      ProjectHours.query(
        {
          foreman_id: $scope.current_foreman_id,
          complete: false,
        },
        function (project_hours) {
          for (var i = 0; i < $scope.submit_tasks.length; i++) {
            var sub_task = $scope.submit_tasks[i];
            var tmptask = $filter("filter")(
              $scope.all_tasks,
              { task_code: sub_task.task },
              true
            );
            var task = $filter("filter")(
              $scope.all_tasks,
              {
                company_code: sub_task.company_code,
                trade_code: sub_task.trade_code,
                job_code: sub_task.job,
                lot: sub_task.lot,
                phase: sub_task.phase,
                task_code: sub_task.task,
              },
              true
            );

            if (task.length !== 1) {
              toaster.pop(
                "error",
                "foreman.js, line 1117",
                "Issue getting the task to be submitted from the global task list. Call admin."
              );
              return;
            }

            if (sub_task.note) {
              task[0].notes.push({
                date: new Date(),
                comment: sub_task.note,
                username: $scope.current_foreman_username,
              });
            }

            if (task[0].status !== "finished" && sub_task.checked) {
              task[0].status = "finished";
              //task[0].complete = true;
              // console.log('saving task ' + task[0].task_code + ' with new date.');

              if ($scope.item.override_date_completion)
                task[0].date_completed = $scope.item.override_date_completion;
              else task[0].date_completed = new Date();
            }

            task[0].$update();

            //all created projecthours are date tagged and
            //sent to the database with the current date.
            //this will pull those hours and override the date.
            if ($scope.item.override_date_completion) {
              var task_list = [];
              task_list = task_list.concat($scope.foreman_tasks);
              for (var j = 0; j < $scope.tradesmen.length; j++) {
                task_list = task_list.concat($scope.tradesmen[j].tasks);
              }

              for (var j = 0; j < task_list.length; j++) {
                var hours = $filter("filter")(
                  project_hours,
                  {
                    _id: task_list[j].hours_id,
                  },
                  true
                );

                if (hours.length === 0) {
                  toaster.pop(
                    "error",
                    "foreman.js, line 1157",
                    "Did not get any hours back from the database. Contact Admin"
                  );
                  return;
                }
                if (hours.length > 1) {
                  toaster.pop(
                    "error",
                    "foreman.js, line 1162",
                    "Got too many hours back from the database.  Contact Admin"
                  );
                  return;
                }

                hours[0].date = $scope.item.override_date_completion;
                hours[0].$update();
              }
            }
          }
        }
      );

      $location.path("home");
    };

    $scope.editItem = function (item) {
      item.editing = true;
    };

    $scope.doneEditing = function (worker, item) {
      if (!item.editing) return;

      var save = $filter("filter")(
        $scope.all_tasks,
        {
          company_code: item.company_code,
          trade_code: item.trade_code,
          job_code: item.job,
          lot: item.lot,
          phase: item.phase,
          task_code: item.task,
        },
        true
      );

      if (save.length === 0) {
        toaster.pop(
          "error",
          "foreman.js, line 1194",
          "Could not find editable task in tradesman task list.  Contact Admin."
        );
        return;
      }

      if (save.length > 1) {
        toaster.pop(
          "error",
          "foreman.js, line 1200",
          "Got more than one editable task back for this tradesman.  Contact Admin."
        );
        return;
      }

      item.hours = Number(item.hours);
      item.cost =
        item.hours * $scope.tradesmen[worker].pay_rate + item.production_bonus;
      $scope.tradesmen[worker].total_hours = 0;
      $scope.tradesmen[worker].total_pay = 0;
      $scope.tradesmen[worker].foreman_total_bonus = 0;

      ProjectHours.query(
        { _id: item.hours_id, complete: false },
        function (hours) {
          if (hours.length === 1) {
            hours[0].hours = item.hours;
            hours[0].pay_total = item.cost;
            hours[0].date = new Date();

            hours[0].$update();
          } else if (hours.length > 1) {
            toaster.pop(
              "error",
              "foreman.js, line 1218",
              "Too many hour entries in the database for this task.  This should not happen. Contact Admin."
            );
            return;
          } else {
            toaster.pop(
              "error",
              "foreman.js, line 1222",
              "Did not get an hours entry from the database for this task. Contact Admin."
            );
            return;
          }

          // need to update total hours and pay since we don't
          // have a reference for the change.
          $scope.tradesmen[worker].tasks.forEach(function (task) {
            $scope.tradesmen[worker].total_hours += task.hours;
            $scope.tradesmen[worker].total_pay += task.cost;
            $scope.tradesmen[worker].foreman_total_bonus +=
              task.production_bonus;
          });

          var thours = 0;
          var tcosts = 0;
          save[0].tradesman.forEach(function (tman) {
            if (tman.username === $scope.tradesmen[worker].username) {
              tman.hours = item.hours;
            }
            thours += tman.hours;
            tcosts += tman.hours * tman.rate + tman.production_bonus;
          });

          thours += save[0].foreman.hours;
          tcosts += save[0].foreman.hours * save[0].foreman.rate;

          save[0].actual_man_hours = thours;
          save[0].actual_labor_costs = tcosts;

          save[0].$update();

          item.editing = false;
        }
      );
    };

    $scope.editForemanItem = function (item) {
      item.foremanEditing = true;
    };

    $scope.doneForemanEditing = function (item) {
      if (!item.foremanEditing) return;

      var save = $filter("filter")(
        $scope.all_tasks,
        {
          company_code: item.company_code,
          trade_code: item.trade_code,
          job_code: item.job,
          lot: item.lot,
          phase: item.phase,
          task_code: item.task,
        },
        true
      );

      if (save.length === 0) {
        toaster.pop(
          "error",
          "foreman.js, line 1273",
          "Could not find editable task in tradesman task list.  Contact Admin."
        );
        return;
      }

      if (save.length > 1) {
        toaster.pop(
          "error",
          "foreman.js, line 1279",
          "Got more than one editable task back for this tradesman.  Contact Admin."
        );
        return;
      }

      item.hours = Number(item.hours);
      item.cost =
        item.hours * $scope.selectedForeman.pay_rate + item.production_bonus;
      $scope.foreman_total_hours = 0;
      $scope.foreman_total_bonus = 0;
      $scope.foreman_total_pay = 0;

      ProjectHours.query(
        { _id: item.hours_id, complete: false },
        function (hours) {
          if (hours.length === 1) {
            hours[0].hours = item.hours;
            hours[0].pay_total = item.cost;
            hours[0].date = new Date();

            hours[0].$update();
          } else if (hours.length > 1) {
            toaster.pop(
              "error",
              "foreman.js, line 1297",
              "Too many hour entries in the database for this task.  This should not happen. Contact Admin."
            );
            return;
          } else {
            toaster.pop(
              "error",
              "foreman.js, line 1301",
              "Did not get an hours entry from the database for this task. Contact Admin."
            );
            return;
          }
        }
      );

      // need to update total hours and pay since we don't
      // have a reference for the change.
      $scope.foreman_tasks.forEach(function (task) {
        $scope.foreman_total_hours += task.hours;
        $scope.foreman_total_bonus += task.production_bonus;
        $scope.foreman_total_pay += task.cost;
      });
      //first subtract out the original foreman hours/costs
      save[0].actual_man_hours -= save[0].foreman.hours;
      save[0].actual_labor_costs -=
        save[0].foreman.hours * save[0].foreman.pay_rate +
        save[0].foreman.production_bonus;

      //now add in the new hours/costs
      save[0].actual_man_hours += item.hours;
      save[0].actual_labor_costs += item.cost;
      save[0].foreman.hours = item.hours;

      save[0].$update();

      item.foremanEditing = false;
    };

    $scope.open = function () {
      $scope.popup.opened = true;
      $scope.item.override_date_completion.setHours(0);
      $scope.item.override_date_completion.setMinutes(0);
      $scope.item.override_date_completion.setSeconds(0);
    };

    $scope.getWorkerHours = function (worker) {
      if (!$scope.clock_hours) return;
      if (!worker) return;

      return $filter("filter")(
        $scope.clock_hours,
        { user: worker._id },
        true
      )[0];
    };

    $rootScope.$on("verifyfailed", function (event, data) {
      if (!loginDialog) return;

      toaster.pop("error", "Password Incorrect");

      loginDialog.close();

      loginDialog = null;
      //$scope.showSpinner = false;
    });

    $scope.clockOperation = function (data, options) {
      if (loginDialog) loginDialog.close();

      switch (options.function) {
        case "ClockIn":
          $scope.ClockInUser(data, options.hour);
          break;
        case "LunchStart":
          $scope.LunchStartUser(data, options.hour);
          break;
        case "LunchEnd":
          $scope.LunchEndUser(data, options.hour);
          break;
        case "ClockOut":
          $scope.ClockOutUser(data, options.hour);
          break;
        default:
        // console.log('unknown case');
      }

      loginDialog = null;
    };

    $rootScope.$on("userVerified", function (event, data) {
      // console.log('verified user identity');
      //if (!loginDialog) return;

      //$scope.showSpinner = true;

      // console.log(event);
      // console.log(data);
      loginDialog.close();

      $scope.clockOperation(data, $scope.returnedOptions);

      // switch ($scope.returnedOptions.function) {
      //     case 'ClockIn':
      //         $scope.ClockInUser(data, $scope.returnedOptions.hour);
      //         break;
      //     case 'LunchStart':
      //         $scope.LunchStartUser(data, $scope.returnedOptions.hour);
      //         break;
      //     case 'LunchEnd':
      //         $scope.LunchEndUser(data, $scope.returnedOptions.hour);
      //         break
      //     case 'ClockOut':
      //         $scope.ClockOutUser(data, $scope.returnedOptions.hour);
      //         break
      //     default:
      //     // console.log('unknown case');
      // }

      //loginDialog = null;
    });

    // $scope.getUserTimecard = function(user) {
    //     var deferred = $q.defer();
    //     var returned_items = [];

    //     //see if the user has a timecard
    //     Timecards.query({'trade_code': userService.getTradeCode(user.username),
    //         'company_code': user.contractor_code,
    //         'type': 'UserDateRange',
    //         'user': user._id,
    //         'start_date': $scope.payStartDate.toDate(),
    //         'end_date': $scope.payEndDate.toDate() }, function(timecardDB) {
    //         console.log(timecardDB);
    //         if(timecardDB.length === 1) {
    //             deferred.resolve(timecardDB[0]);
    //         } else {
    //             deferred.resolve(null);
    //         }
    //     });

    //     return deferred.promise;
    // };

    // $scope.createUserTimecard = function(user, retFunc) {
    //     $scope.getUserTimecard(user).then(function(timecard) {
    //         if(!timecard) {
    //             var time = new Timecards({
    //                 user: user,
    //                 trade_code: userService.getTradeCode(user.username),
    //                 company_code: user.contractor_code,
    //                 start_date: new Date($scope.payStartDate),
    //                 end_date: new Date($scope.payEndDate),
    //                 signed: false,
    //             });

    //             time.$save(function(success) {
    //                 //$scope.current_timecards.push(success);
    //                 retFunc(success);
    //                 toaster.pop('success', 'Time Card Created');
    //             }, function(error) {
    //                 toaster.pop('error', 'Time Card Error', error);
    //             });
    //         } else {
    //             if($scope.current_timecards.indexOf(timecard) === -1) {
    //                 $scope.current_timecards.push(timecard);
    //             }
    //         }
    //     });
    // }

    // $scope.saveOrUpdateTimecardFromHours = function(user, hour) {
    //     var inlist = -1;
    //     for(var i=0; i<$scope.current_timecards.length; i++) {
    //         if($scope.current_timecards[i].user._id === user._id) {
    //             inlist = i;
    //             break;
    //         }
    //     }

    //     if(inlist === -1) {
    //         $scope.getUserTimecard(user).then(function(timecard) {
    //             if(timecard) {
    //                 $scope.updateTimecardHour(timecard, hour);
    //             }
    //         });
    //     } else {
    //         //update a timecard
    //         $scope.updateTimecardHour($scope.current_timecards[inlist], hour);
    //     }
    // };

    // $scope.updateTimecardHour = function(timecard, hour) {
    //     var idx = timecard.hours.findIndex(x => x._id === hour._id);
    //     if(idx === -1) {
    //         timecard.hours.push(hour);

    //         timecard.$update(function(success) {
    //             var idx = $scope.current_timecards.indexOf(success);
    //             if(idx === -1) {
    //                 $scope.current_timecards.push(success);
    //             } else {
    //                 $scope.current_timecards[idx] = success;
    //             }
    //             toaster.pop('success', 'Time Card Updated');
    //         }, function(error) {
    //             toaster.pop('error', 'Time Card Error', error);
    //         });
    //     }
    // };

    // $scope.addLaborHoursToTimecard = function(user, labor) {
    //     $scope.getUserTimecard(user).then(function(timecard) {
    //         if(timecard) {
    //             if(!timecard.total) {
    //                 timecard.total = {
    //                     hours: 0
    //                 }
    //             }

    //             timecard.total.hours += labor;
    //             timecard.$update(function(success) {
    //                 toaster.pop('success', 'Time Card Updated');
    //             }, function(error) {
    //                 toaster.pop('error', 'Time Card Error', error);
    //             });
    //         }
    //     });
    // };

    // $scope.removeLaborHoursFromTimecard = function(user, labor) {
    //     $scope.getUserTimecard(user).then(function(timecard) {
    //         if(timecard) {
    //             timecard.total.hours -= labor;
    //             timecard.$update(function(success) {
    //                 toaster.pop('success', 'Time Card Updated');
    //             }, function(error) {
    //                 toaster.pop('error', 'Time Card Error', error);
    //             });
    //         }
    //     });
    // };

    $scope.foremanClockIn = function (user, hour) {
      if (hour && hour.clock_in) {
        toaster.pop("warning", user.name + " has already clocked in.");
        return;
      }

      //$scope.showSpinner = true;

      if ($scope.is_foreman && $scope.selectedForeman == user) {
        //this is the foreman logging time for himself
        myCoordinates.get().then(function (coords) {
          if (hour) {
            toaster.pop("error", "Hours Error", "Already Clocked In");
            return;
          }

          hour = new Hours({
            user: user._id,
            date: new Date(),
            trade_code: $scope.my_trade_code,
            company_code: $scope.user.contractor_code,
            clock_in: {
              time: new Date(),
              code: "E",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            },
          });

          hour.$save(function (success) {
            var user_holder = angular.copy(success.user);
            success.user = success.user._id;
            success.date = new Date(success.date);
            success.clock_in.time = new Date(success.clock_in.time);

            //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

            $scope.clock_hours.push(success);
            //$scope.showSpinner = false;
          });
        });
      } else if (
        ($scope.is_foreman && $scope.selectedForeman != user) ||
        $scope.is_manager
      ) {
        //this is the foremans account but logging time for another user
        //prompt for password
        $scope.returnedOptions = {
          username: user.username,
          password: "",
          function: "ClockIn",
          type: "DailyReportVerification",
          hour: hour,
        };

        if ($scope.require_passwords) {
          loginDialog = ngDialog.open({
            template: "foreman/views/tmpl/password.html",
            scope: $scope,
            className: "ngdialog-theme-default",
          });
        } else {
          $scope.clockOperation(user, $scope.returnedOptions);
        }
      }
    };

    $scope.ClockInUser = function (user, hour) {
      myCoordinates.get().then(function (coords) {
        if (hour) {
          toaster.pop("error", "Hours Error", "Already Clocked In");
          return;
        }

        hour = new Hours({
          user: user._id,
          date: new Date(),
          trade_code: $scope.my_trade_code,
          company_code: $scope.user.contractor_code,
          clock_in: {
            time: new Date(),
            code: "E",
            location: {
              lat: coords.lat,
              lon: coords.lon,
            },
            ip: coords.ip,
          },
        });

        hour.$save(function (success) {
          var user_holder = angular.copy(success.user);
          success.user = success.user._id;
          success.date = new Date(success.date);
          success.clock_in.time = new Date(success.clock_in.time);

          //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

          $scope.clock_hours.push(success);
          //$scope.showSpinner = false;
        });
      });
    };

    $scope.foremanLunchStart = function (user, hour) {
      if (hour && hour.lunch_start) {
        toaster.pop("warning", user.name + " has already started lunch.");
        return;
      }
      //$scope.showSpinner = true;

      if ($scope.is_foreman && $scope.selectedForeman == user) {
        if (!hour) {
          $scope.overrideHoursOperation("lunch_start", user, hour);
        } else {
          if (hour.lunch_start) {
            toaster.pop("error", "Hours Error", "Already Entered Lunch Start");
            return;
          }

          myCoordinates.get().then(function (coords) {
            hour.lunch_start = {
              time: new Date(),
              code: "E",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };

            hour.$update(function (success) {
              //var user_holder = angular.copy(success.user);
              success.user = success.user._id;
              success.date = new Date(success.date);
              success.clock_in.time = new Date(success.clock_in.time);
              success.lunch_start.time = new Date(success.lunch_start.time);

              //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

              var inlist = $scope.getWorkerHours(user);
              inlist = success;
              //$scope.showSpinner = false;
            });
          });
        }
      } else if (
        ($scope.is_foreman && $scope.selectedForeman != user) ||
        $scope.is_manager
      ) {
        //this is the foremans account but logging time for another user
        //prompt for password
        $scope.returnedOptions = {
          username: user.username,
          password: "",
          function: "LunchStart",
          type: "DailyReportVerification",
          hour: hour,
        };

        if ($scope.require_passwords) {
          loginDialog = ngDialog.open({
            template: "foreman/views/tmpl/password.html",
            scope: $scope,
            className: "ngdialog-theme-default",
          });
        } else {
          $scope.clockOperation(user, $scope.returnedOptions);
        }
      }
    };

    $scope.LunchStartUser = function (user, hour) {
      if (!hour) {
        $scope.overrideHoursOperation("lunch_start", user, hour);
      } else {
        myCoordinates.get().then(function (coords) {
          hour.lunch_start = {
            time: new Date(),
            code: "E",
            location: {
              lat: coords.lat,
              lon: coords.lon,
            },
            ip: coords.ip,
          };

          hour.$update(function (success) {
            //var user_holder = angular.copy(success.user);
            success.user = success.user._id;
            success.date = new Date(success.date);
            success.clock_in.time = new Date(success.clock_in.time);
            success.lunch_start.time = new Date(success.lunch_start.time);

            //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

            var inlist = $scope.getWorkerHours(user);
            inlist = success;
            //$scope.showSpinner = false;
          });
        });
      }
    };

    $scope.checkMinLunch = function (hour) {
      if ($scope.typical.mandatory_lunch) {
        var lunch_start = moment(hour.lunch_start.time);
        var lunch_end = moment();
        var time = moment.duration(lunch_end.diff(lunch_start));
        var minutes = time.hours() * 60;
        minutes += time.minutes();
        if (minutes < $scope.typical.lunch_minimum) {
          toaster.pop(
            "error",
            "Cannot Clock Lunch End yet. ",
            "Mandatory lunch break minimum is " +
              $scope.typical.lunch_minimum +
              " minutes not " +
              time.minutes() +
              " minutes."
          );
          return false;
        }
      }

      return true;
    };

    $scope.foremanLunchEnd = function (user, hour) {
      if (hour && hour.lunch_end) {
        toaster.pop(
          "warning",
          user.name + " has already clocked back in from lunch."
        );
        return;
      }
      //$scope.showSpinner = true;
      if ($scope.is_foreman && $scope.selectedForeman == user) {
        if (!hour) {
          $scope.overrideHoursOperation("lunch_end", user, hour);
        } else {
          if (!hour.lunch_start) {
            $scope.overrideHoursOperation("lunch_end", user, hour);
          } else {
            if ($scope.checkMinLunch(hour)) {
              myCoordinates.get().then(function (coords) {
                hour.lunch_end = {
                  time: new Date(),
                  code: "E",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };

                hour.$update(function (success) {
                  //var user_holder = angular.copy(success.user);
                  success.user = success.user._id;
                  success.date = new Date(success.date);
                  success.clock_in.time = new Date(success.clock_in.time);
                  success.lunch_start.time = new Date(success.lunch_start.time);
                  success.lunch_end.time = new Date(success.lunch_end.time);

                  //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

                  var inlist = $scope.getWorkerHours(user);
                  inlist = success;
                  //$scope.showSpinner = false;
                });
              });
            }
          }
        }
      } else if (
        ($scope.is_foreman && $scope.selectedForeman != user) ||
        $scope.is_manager
      ) {
        //this is the foremans account but logging time for another user
        //prompt for password
        $scope.returnedOptions = {
          username: user.username,
          password: "",
          function: "LunchEnd",
          type: "DailyReportVerification",
          hour: hour,
        };

        if ($scope.require_passwords) {
          loginDialog = ngDialog.open({
            template: "foreman/views/tmpl/password.html",
            scope: $scope,
            className: "ngdialog-theme-default",
          });
        } else {
          $scope.clockOperation(user, $scope.returnedOptions);
        }
      }
    };

    $scope.LunchEndUser = function (user, hour) {
      if (!hour) {
        $scope.overrideHoursOperation("lunch_end", user, hour);
      } else {
        if (!hour.lunch_start) {
          $scope.overrideHoursOperation("lunch_end", user, hour);
        } else {
          if ($scope.checkMinLunch(hour)) {
            myCoordinates.get().then(function (coords) {
              hour.lunch_end = {
                time: new Date(),
                code: "E",
                location: {
                  lat: coords.lat,
                  lon: coords.lon,
                },
                ip: coords.ip,
              };

              hour.$update(function (success) {
                //var user_holder = angular.copy(success.user);
                success.user = success.user._id;
                success.date = new Date(success.date);
                success.clock_in.time = new Date(success.clock_in.time);
                success.lunch_start.time = new Date(success.lunch_start.time);
                success.lunch_end.time = new Date(success.lunch_end.time);

                //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

                var inlist = $scope.getWorkerHours(user);
                inlist = success;
                //$scope.showSpinner = false;
              });
            });
          }
        }
      }
    };

    $scope.foremanClockOut = function (user, hour) {
      if (hour && hour.clock_out) {
        toaster.pop("warning", user.name + " has already clocked out.");
        return;
      }
      //$scope.showSpinner = true;
      if ($scope.is_foreman && $scope.selectedForeman == user) {
        if (!hour) {
          $scope.overrideHoursOperation("clock_out", user, hour);
        } else {
          if (!hour.lunch_start) {
            $scope.overrideHoursOperation("clock_out", user, hour);
          } else if (!hour.lunch_end) {
            $scope.overrideHoursOperation("clock_out", user, hour);
          } else {
            myCoordinates.get().then(function (coords) {
              hour.clock_out = {
                time: new Date(),
                code: "E",
                location: {
                  lat: coords.lat,
                  lon: coords.lon,
                },
                ip: coords.ip,
              };

              hour.$update(function (success) {
                //var user_holder = angular.copy(success.user);
                success.user = success.user._id;
                success.date = new Date(success.date);
                success.clock_in.time = new Date(success.clock_in.time);
                success.lunch_start.time = new Date(success.lunch_start.time);
                success.lunch_end.time = new Date(success.lunch_end.time);
                success.clock_out.time = new Date(success.clock_out.time);

                //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

                //$scope.showSpinner = false;

                var inlist = $scope.getWorkerHours(user);
                inlist = success;
                $scope.updateProjectHours();

                if ($scope.finalSubmitChecker) {
                  $scope.finalSubmitChecker = false;
                  // console.log('FINAL SUBMIT PART AND SENDING TO /');
                  $location.url("/");
                }
              });
            });
          }
        }
      } else if (
        ($scope.is_foreman && $scope.selectedForeman != user) ||
        $scope.is_manager
      ) {
        //this is the foremans account but logging time for another user
        //prompt for password
        $scope.returnedOptions = {
          username: user.username,
          password: "",
          function: "ClockOut",
          type: "DailyReportVerification",
          hour: hour,
        };

        if ($scope.require_passwords) {
          loginDialog = ngDialog.open({
            template: "foreman/views/tmpl/password.html",
            scope: $scope,
            className: "ngdialog-theme-default",
          });
        } else {
          $scope.clockOperation(user, $scope.returnedOptions);
        }
      }
    };

    $scope.ClockOutUser = function (user, hour) {
      if (!hour) {
        $scope.overrideHoursOperation("clock_out", user, hour);
      } else {
        if (!hour.lunch_start) {
          $scope.overrideHoursOperation("clock_out", user, hour);
        } else if (!hour.lunch_end) {
          $scope.overrideHoursOperation("clock_out", user, hour);
        } else {
          myCoordinates.get().then(function (coords) {
            hour.clock_out = {
              time: new Date(),
              code: "E",
              location: {
                lat: coords.lat,
                lon: coords.lon,
              },
              ip: coords.ip,
            };

            hour.$update(function (success) {
              //var user_holder = angular.copy(success.user);
              success.user = success.user._id;
              success.date = new Date(success.date);
              success.clock_in.time = new Date(success.clock_in.time);
              success.lunch_start.time = new Date(success.lunch_start.time);
              success.lunch_end.time = new Date(success.lunch_end.time);
              success.clock_out.time = new Date(success.clock_out.time);

              //$scope.saveOrUpdateTimecardFromHours(user_holder, success);

              //$scope.showSpinner = false;

              var inlist = $scope.getWorkerHours(user);
              inlist = success;

              if ($scope.finalSubmitChecker) {
                $scope.finalSubmitChecker = false;
                $scope.updateProjectHours();
                // console.log('FINAL SUBMIT PART AND SENDING TO /');
                $location.url("/");
              }
            });
          });
        }
      }
    };

    //this function is called when the foreman does the final
    //submit for the day.  It will check his hours and prompt
    //if time is missing.  Then it will loop through all the
    //tradesmen and check their time and update to foreman's
    //time if missing.
    $scope.finalClockOut = function (foreman_hour) {
      var defer = $q.defer();

      foreman_hour.$update(function (success) {
        success.user = success.user._id;
        //$scope.checkTradesmenHours(success);
        defer.resolve("Success");
      });

      return defer.promise;
    };

    $scope.checkTradesmenHours = function (foreman_hour) {
      //get latest hours from the database
      Hours.query(
        {
          date: new Date(),
          type: "NoPopulate",
          trade_code: $scope.my_trade_code,
          company_code: $scope.user.contractor_code,
        },
        function (hours) {
          _.each($scope.tradesmen, function (worker) {
            var inlist = $filter("filter")(hours, { user: worker._id }, true);
            var worker_hour = null;
            var save_new = false;

            if (inlist.length === 0) {
              save_new = true;
              worker_hour = new Hours({
                user: worker._id,
                date: new Date(),
                trade_code: $scope.my_trade_code,
                company_code: $scope.user.contractor_code,
                clock_in: {
                  time: new Date(foreman_hour.clock_in.time),
                  code: "F",
                  location: {
                    lat: foreman_hour.clock_in.location.lat,
                    lon: foreman_hour.clock_in.location.lon,
                  },
                  ip: foreman_hour.clock_in.ip,
                },
              });
            } else if (inlist.length === 1) {
              worker_hour = inlist[0];
            } else {
              toaster.pop(
                "error",
                "Time Card Error",
                "Too many hour entries for " + worker.username
              );
            }

            if (!worker_hour.lunch_start) {
              worker_hour.lunch_start = {
                time: new Date(foreman_hour.lunch_start.time),
                code: "F",
                location: {
                  lat: foreman_hour.lunch_start.location.lat,
                  lon: foreman_hour.lunch_start.location.lon,
                },
                ip: foreman_hour.lunch_start.ip,
              };
            }

            if (!worker_hour.lunch_end) {
              worker_hour.lunch_end = {
                time: new Date(foreman_hour.lunch_end.time),
                code: "F",
                location: {
                  lat: foreman_hour.lunch_end.location.lat,
                  lon: foreman_hour.lunch_end.location.lon,
                },
                ip: foreman_hour.lunch_end.ip,
              };
            }

            if (!worker_hour.clock_out) {
              worker_hour.clock_out = {
                time: new Date(foreman_hour.clock_out.time),
                code: "F",
                location: {
                  lat: foreman_hour.clock_out.location.lat,
                  lon: foreman_hour.clock_out.location.lon,
                },
                ip: foreman_hour.clock_out.ip,
              };
            }

            if (save_new) {
              worker_hour.$save(function (success) {
                success.user = success.user._id;
              });
            } else
              worker_hour.$update(function (success) {
                success.user = success.user._id;
              });
          });
        }
      );
    };

    $scope.overrideHoursOperation = function (
      caller,
      user,
      hours,
      final_clock_out
    ) {
      var need_in = hours ? false : true; //hours object does not exist so must create
      var need_start = false;
      var need_end = false;
      var need_out = false;

      switch (caller) {
        case "clock_in":
          break;
        case "lunch_start":
          need_in = hours && hours.clock_in ? false : true;
          break;
        case "lunch_end":
          need_in = hours && hours.clock_in ? false : true;
          need_start = hours && hours.lunch_start ? false : true;
          break;
        case "clock_out":
          need_in = hours && hours.clock_in ? false : true;
          need_start = hours && hours.lunch_start ? false : true;
          need_end = hours && hours.lunch_end ? false : true;
          break;
        default:
        // console.log('unknown case');
      }

      //get the system defined default times for what is needed
      //and set the value for the user here.
      $scope.returnedOptions = {
        hours: hours,
        need_clock_in: need_in,
        need_lunch_start: need_start,
        need_lunch_end: need_end,
        need_clock_out: need_out,
        caller: caller,
      };

      ngDialog
        .openConfirm({
          template: "foreman/views/tmpl/update-hours.html",
          scope: $scope,
          className: "ngdialog-theme-default",
        })
        .then(
          function (value) {
            var hourDoc;

            if (!$scope.returnedOptions.need_clock_in) {
              hourDoc = $scope.returnedOptions.hours;
            }

            myCoordinates.get().then(function (coords) {
              //these will take the user input from the popup
              if ($scope.returnedOptions.need_clock_in) {
                hourDoc = new Hours({
                  user: user._id,
                  date: new Date(),
                  trade_code: $scope.my_trade_code,
                  company_code: $scope.user.contractor_code,
                  clock_in: {
                    time: new Date($scope.returnedOptions.hours.clock_in.time),
                    code: "E",
                    location: {
                      lat: coords.lat,
                      lon: coords.lon,
                    },
                    ip: coords.ip,
                  },
                });

                hourDoc.clock_in.time.setSeconds(0);
              }

              if ($scope.returnedOptions.need_lunch_start) {
                hourDoc.lunch_start = {
                  time: new Date($scope.returnedOptions.hours.lunch_start.time),
                  code: "E",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };

                hourDoc.lunch_start.time.setSeconds(0);
              }

              if ($scope.returnedOptions.need_lunch_end) {
                hourDoc.lunch_end = {
                  time: new Date($scope.returnedOptions.hours.lunch_end.time),
                  code: "E",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };

                hourDoc.lunch_end.time.setSeconds(0);
              }

              if ($scope.returnedOptions.need_clock_out) {
                hourDoc.clock_out = {
                  time: new Date($scope.returnedOptions.hours.clock_out.time),
                  code: "E",
                  location: {
                    lat: coords.lat,
                    lon: coords.lon,
                  },
                  ip: coords.ip,
                };

                hourDoc.clock_out.time.setSeconds(0);
              }

              //this will set the current date/time to whatever clock button
              //was clicked
              switch ($scope.returnedOptions.caller) {
                case "clock_in":
                  break;
                case "lunch_start":
                  hourDoc.lunch_start = {
                    time: new Date(),
                    code: "E",
                    location: {
                      lat: coords.lat,
                      lon: coords.lon,
                    },
                    ip: coords.ip,
                  };

                  //hourDoc.lunch_start.time.setSeconds(0);
                  break;
                case "lunch_end":
                  if (!$scope.checkMinLunch($scope.returnedOptions.hours)) {
                    return;
                  }
                  hourDoc.lunch_end = {
                    time: new Date(),
                    code: "E",
                    location: {
                      lat: coords.lat,
                      lon: coords.lon,
                    },
                    ip: coords.ip,
                  };

                  //hourDoc.lunch_end.time.setSeconds(0);
                  break;
                case "clock_out":
                  hourDoc.clock_out = {
                    time: new Date(),
                    code: "E",
                    location: {
                      lat: coords.lat,
                      lon: coords.lon,
                    },
                    ip: coords.ip,
                  };

                  //hourDoc.clock_out.time.setSeconds(0);
                  break;
                default:
                // console.log('unknown case');
              }

              if ($scope.returnedOptions.need_clock_in) {
                //need to create the hours object
                hourDoc.$save(function (success) {
                  //commented this out because I cannot remember why it's here.
                  //will need to test a bunch to verify removing is ok.
                  //var user_copy = angular.copy(success.user);
                  //$scope.overrideHoursOperation('clock_in', user_copy, success);
                  success.user = success.user._id;
                  success.date = new Date(success.date);
                  success.clock_in.time = new Date(success.clock_in.time);
                  if (success.lunch_start)
                    success.lunch_start.time = new Date(
                      success.lunch_start.time
                    );
                  if (success.lunch_end)
                    success.lunch_end.time = new Date(success.lunch_end.time);
                  if (success.clock_out)
                    success.clock_out.time = new Date(success.clock_out.time);
                  //$scope.showSpinner = false;

                  $scope.clock_hours.push(success);

                  var inlist = $scope.getWorkerHours(user);
                  inlist = success;

                  if (
                    user === $scope.selectedForeman &&
                    final_clock_out === true
                  ) {
                    $scope.checkTradesmenHours(success);
                  }
                });
              } else {
                //need to update the hours object
                hourDoc.$update(function (success) {
                  success.user = success.user._id;
                  success.date = new Date(success.date);
                  success.clock_in.time = new Date(success.clock_in.time);
                  if (success.lunch_start)
                    success.lunch_start.time = new Date(
                      success.lunch_start.time
                    );
                  if (success.lunch_end)
                    success.lunch_end.time = new Date(success.lunch_end.time);
                  if (success.clock_out)
                    success.clock_out.time = new Date(success.clock_out.time);
                  //$scope.showSpinner = false;

                  var inlist = $scope.getWorkerHours(user);
                  inlist = success;

                  if (
                    user === $scope.selectedForeman &&
                    final_clock_out === true
                  ) {
                    $scope.checkTradesmenHours(success);
                  }
                });
              }
            });
          },
          function (value) {
            //Do something
          }
        );
    };

    $scope.clockCrew = function () {
      $scope.clockCrewOptions = {
        tradesmen: $scope.tradesmen,
        foreman: $scope.selectedForeman,
        hours: $scope.clock_hours,
        function: "ClockCrew",
        type: "DailyReportVerification",
      };

      ngDialog.open({
        template: "foreman/views/tmpl/clock-crew.html",
        scope: $scope,
        className: "ngdialog-theme-default",
      });
    };

    $scope.saveNotes = function (task) {
      if (!task.note) return;
      console.log("task detaiss", task);
      task.savingNote = true;
      var taskComments = angular.copy(task.note);
      // find tasks
      var foundTask = $filter("filter")(
        $scope.all_tasks,
        {
          company_code: task.company_code,
          trade_code: task.trade_code,
          job_code: task.job,
          lot: task.lot,
          phase: task.phase,
          task_code: task.task,
        },
        true
      );

      if (foundTask.length) {
        if (task.note) {
          foundTask[0].notes.push({
            date: new Date(),
            comment: taskComments,
            username: $scope.current_foreman_username,
          });

          foundTask[0].$update(function (result) {
            DocumentSevice.query(
              {
                type: "noteComments",
                nodeType: "document",
                projectPhase: task.phase,
                projectId: task.project_id,
                mainAccountId: $scope.main_id,
              },
              function (result) {
                if (result.length) {
                  ProjectHours.query(
                    { _id: task.hours_id, complete: false },
                    function (hours) {
                      if (hours.length) {
                        hours[0].$update(function (savedHours) {
                          AWSUploadService.query(
                            {
                              type: "findLotDoc",
                              documentId: result[0]._id,
                              mainAccountId: $scope.main_id,
                              fileName: task.lot + ".pdf",
                            },
                            function (awsDocs) {
                              if (awsDocs.length) {
                                var username =
                                  $scope.is_admin || $scope.is_manager
                                    ? $scope.user.username
                                    : $scope.current_foreman_username;

                                var name =
                                  $scope.is_admin || $scope.is_manager
                                    ? $scope.user.name
                                    : $scope.selectedForeman.name;

                                var newComments = {
                                  user: username,
                                  name: name,
                                  text: taskComments,
                                  type: "text",
                                  read: [username],
                                };
                                awsDocs[0].comments.push(newComments);
                                awsDocs[0].$update(function (done) {
                                  toaster.pop(
                                    "success",
                                    "Note",
                                    "Task note saved successfully."
                                  );
                                  task.savingNote = false;
                                  task.note = null;
                                });
                              } else {
                                toaster.pop(
                                  "success",
                                  "Note",
                                  "Task note saved successfully."
                                );
                                task.savingNote = false;
                                task.note = null;
                              }
                            }
                          );
                        });
                      } else {
                        toaster.pop(
                          "success",
                          "Note",
                          "Task note saved successfully."
                        );
                        task.savingNote = false;
                        task.note = null;
                      }
                    }
                  );
                } else {
                  toaster.pop(
                    "success",
                    "Note",
                    "Task note saved successfully."
                  );
                  task.savingNote = false;
                  task.note = null;
                }
              },
              function (error) {
                task.savingNote = false;
                task.note = null;
              }
            );
          });
        }
      } else {
        task.savingNote = false;
        task.note = null;
      }
    };

    $scope.uploadNote = function (file, task) {
      if (file === null) return;
      task.savingNote = true;

      DocumentSevice.query(
        {
          type: "noteComments",
          nodeType: "document",
          projectPhase: task.phase,
          projectId: task.project_id,
          mainAccountId: $scope.main_id,
        },
        function (result) {
          if (result.length) {
            Upload.upload({
              url: "/api/awsUploads",
              data: {
                file: file,
                documentId: result[0]._id,
                pathPrefix: result[0].pathPrefix,
                mainAccountId: $scope.main_id,
                uploadedBy: $scope.user.username,
              },
            }).then(
              function (resp) {
                task.savingNote = false;
                if (resp.data.url) {
                  task.attachmenturl = resp.data.url;
                  var leafname = resp.data.url
                    .split("\\")
                    .pop()
                    .split("/")
                    .pop();
                  task["note"] = task.note
                    ? task.note + " Image " + leafname + " Added"
                    : "Image " + leafname + " Added";
                } else {
                  toaster.pop(
                    "error",
                    "Upload Error",
                    "Kindly check your project document structure."
                  );
                }
              },
              function (error) {
                task.savingNote = false;
                toaster.pop("error", "Upload Error", error.data.error);
              }
            );
          } else {
            task.savingNote = false;
            toaster.pop(
              "error",
              "Upload Error",
              "Kindly check your project document structure."
            );
          }
        }
      );
    };
  },
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/foreman.js